/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ExpirationType {
  EndOfDay = 'EndOfDay',
  DurationBased = 'DurationBased',
  SpecificDate = 'SpecificDate',
}

export enum DurationExpirationUnit {
  Hours = 'Hours',
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months',
}

export type DurationExpirationUnitKeys = keyof typeof DurationExpirationUnit;

export interface TicketTypeImageModel {
  image?: string;
  name?: string;
  size?: number | null;
  url?: string;
}

export interface FanguardApiContractsTicketTypesResponseModel {
  id: string;
  name: string;
  color: string;
  description?: string;
  logo?: TicketTypeImageModel | null;

  durationExpiration?: number | null;
  durationExpirationUnit?: DurationExpirationUnitKeys | null;

  expirationCalendarDate?: string | null;
  expirationCalendarTime?: string | null;

  expirationType: ExpirationType;
  expirationDate?: Date | null;
}

export interface FanguardApiContractsClientDayPassCreateRequestModel {
  id?: string | null;
  name: string;
  color: string;
  description?: string;
  logo?: TicketTypeImageModel | null;

  durationExpiration?: number | null;
  durationExpirationUnit?: DurationExpirationUnitKeys | null;
  expirationCalendarDate?: string | null;
  expirationCalendarTime?: string | null;
  expirationDate?: Date | null;
  expirationType: ExpirationType;
}

export interface FanguardApiContractsNotificationModel {
  client: string;
  notificationType: FanguardApiContractsNotificationTypeEnum;
  message: string;
  title: string;
  id: string;
  timestamp: Date | string;
  imageUrl: string;
  indicator: FanguardApiContractsNotificationIndicatorEnum;
  passed: boolean;
}

export interface NotificationExtended extends FanguardApiContractsNotificationModel {
  processed?: number;
  totalRows?: number;
  jobId?: string;
  listName?: string;
}

export type FanguardApiContractsJobNotificationModelModel = Omit<FanguardApiContractsNotificationModel, 'client'> & {
  client: string | null;
  level: string;
};

export type FanguardApiContractsStepUpdateNotificationModel = Omit<
  FanguardApiContractsNotificationModel,
  'number' | 'passed'
> & {
  number: string;
  passed?: boolean;
};

export enum FanguardApiContractsNotificationIndicatorEnum {
  Success = 'Success',
  Information = 'Information',
  Warning = 'Warning',
  Failure = 'Failure',
  BulkImport = 'BulkImport',
}

export type FanguardApiContractsNotificationIndicatorEnumKeys =
  keyof typeof FanguardApiContractsNotificationIndicatorEnum;

export enum FanguardApiContractsNotificationTypeEnum {
  AlertCreated = 1,
  AlertStatusUpdated,
  AccessGranted,
  AccessDenied,
  SensorStatusChanged,
  CrowdCountThresholdExceeded,
  TicketRedemptionSuccessful,
  TicketRedemptionPartialFailure,
  DeviceStatusChanged,
}

export type FanguardApiContractsNotificationTypeEnumKeys = keyof typeof FanguardApiContractsNotificationTypeEnum;

/** @format int32 */
export enum FanguardApiContractsAlertAlertStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

/** @format int32 */
export enum FanguardApiContractsAlertFilterType {
  List,
  Range,
  DateTime,
  Checkbox,
}

export type FanguardApiContractsAlertFilterTypeEnumKeys = keyof typeof FanguardApiContractsAlertFilterType;

/** @format int32 */
export enum FanguardApiContractsBoxBatteryStateModelEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum FanguardApiContractsBoxDeviceDetailStatusEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
}

/** @format int32 */
export enum FanguardApiContractsBoxPairingStatus {
  Unavailable,
  TimedOut,
  Connecting,
  Connected,
  NotConnected,
}

export type FanguardApiContractsBoxPairingStatusKeys = keyof typeof FanguardApiContractsBoxPairingStatus;

export enum FanguardApiContractsBoxDisplayMode {
  Light,
  Dark,
  Auto,
  Unknown,
}

export type FanguardApiContractsBoxDisplayModeKeys = keyof typeof FanguardApiContractsBoxDisplayMode;

export interface FanguardApiContractsBoxSensorBeatRequestModel {
  command?: string | null;
  sensorId?: string | null;
  status?: FanguardApiContractsBoxDeviceDetailStatusEnum;
  softwareVersion?: string | null;
  /** @format double */
  fps?: number;
  /** @format int32 */
  frameWidth?: number;
  /** @format int32 */
  frameHeight?: number;
  /** @format double */
  cpuUtilization?: number;
  /** @format double */
  memoryUtilization?: number;
  /** @format double */
  memoryTotal?: number | null;
  /** @format double */
  memoryUsed?: number | null;
  /** @format double */
  diskSpaceTotal?: number | null;
  /** @format double */
  diskSpaceUsed?: number | null;
  /** @format double */
  videoPreprocessingTime?: number | null;
  /** @format double */
  intercommunicationTime?: number | null;
  /** @format double */
  identificationTime?: number | null;
  /** @format double */
  totalTime?: number | null;
  /** @format double */
  classificationTime?: number | null;
  metrics?: FanguardApiContractsBoxSensorMetricRequestModel[] | null;
  watchlists?: FanguardApiContractsBoxSensorWatchlistRequestModel[] | null;
  configurationVersion?: string | null;
  ipAddress?: string | null;
  /** @format date-time */
  timestamp?: string;
  /** @format double */
  batteryLevel?: number | null;
  batteryState?: FanguardApiContractsBoxBatteryStateModelEnum;
  frNetworks?: string[] | null;
  pairingStatus?: FanguardApiContractsBoxPairingStatusKeys;
  deviceMode?: FanguardApiContractsBoxPairingStatusKeys;
}

export interface FanguardApiContractsBoxSensorMetricRequestModel {
  name?: string | null;
  /** @format double */
  value?: number;
}

export interface FanguardApiContractsBoxSensorWatchlistRequestModel {
  watchlistId?: string | null;
  classifierId?: string | null;
  /** @format date-time */
  lastModifiedOn?: string | null;
}

export interface FanguardApiContractsBoxServiceKeyModel {
  id?: string | null;
  secretKey?: string | null;
}

export interface FanguardApiContractsClientAgreementModel {
  id?: string | null;
  key?: string | null;
  /** @format int32 */
  version?: number;
  body?: string | null;
}

export interface FanguardApiContractsClientAssetModel {
  id?: string | null;
  key?: string | null;
  name?: string | null;
  url?: string | null;
  /** @format int64 */
  size?: number;
  /** @format date-time */
  lastModified?: string;
  eTag?: string | null;
}

export interface FanguardApiContractsClientCampaignCreateRequestModel {
  /** @minLength 1 */
  name: string;
}

export interface FanguardApiContractsClientCampaignDetailModel {
  id?: string | null;
  name?: string | null;
  tagline?: string | null;
  pathSegment?: string | null;
  promoText?: string | null;
  program?: string | null;
  programDetail?: FanguardApiContractsClientCampaignProgramDetail;
  linkAccountUrl?: string | null;
  /** @format int32 */
  requiredMinimumAge?: number | null;
  venueId?: string | null;
  listId?: string | null;
  enabled?: boolean | null;
  requireId?: boolean | null;
  enrollmentByRequestOnly?: boolean | null;
  requestEnrollmentTemplateId?: string | null;
  emailVerificationTemplateId?: string | null;
  registrationCompleteTemplateId?: string | null;
  registrationMissingPhotosTemplateId?: string | null;
  /** @format int32 */
  noPhotoEmailReminderDelay?: number;
  registrationIncompleteTemplateId?: string | null;
  /** @format int32 */
  incompleteCampaignReminderDelay?: number;
  content?: FanguardApiContractsClientContentModel;
  connectionId?: string | null;
  walletConnectionId?: string | null;
  dayPassTicketingCampaignSiteId?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsClientCampaignProgram {
  Value0 = 0,
  Value1 = 1,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum FanguardApiContractsClientCampaignProgramDetail {
  Value0 = 0,
  Value1 = 1,
}

export interface FanguardApiContractsClientCampaignUpdateRequestModel {
  id: string;
  campaignId: string;
  name?: string | null;
  tagline?: string | null;
  pathSegment?: string | null;
  promoText?: string | null;
  program?: string | null;
  /** @format int32 */
  requiredMinimumAge?: number | null;
  listId?: string | null;
  venueId?: string | null;
  enabled?: boolean | null;
  requireId?: boolean | null;
  enrollmentByRequestOnly?: boolean | null;
  requestEnrollmentTemplateId?: string | null;
  emailVerificationTemplateId?: string | null;
  registrationCompleteTemplateId?: string | null;
  registrationMissingPhotosTemplateId?: string | null;
  /** @format int32 */
  noPhotoEmailReminderDelay?: number | null;
  registrationIncompleteTemplateId?: string | null;
  /** @format int32 */
  incompleteCampaignReminderDelay?: number | null;
  content?: FanguardApiContractsClientContentModel;
  connectionId?: string | null;
  walletConnectionId?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsClientClientAuthenticationPlatformEnum {
  'Local' = 'Local',
  'Auth0' = 'Auth0',
}

export interface FanguardApiContractsClientClientAuthenticationSettingsModel {
  platform?: FanguardApiContractsClientClientAuthenticationPlatformEnum;
  domain?: string | null;
  clientId?: string | null;
  managementClientId?: string | null;
  managementApiAudience?: string | null;
  clientSecret?: string | null;
  managementClientSecret?: string | null;
}

export interface FanguardApiContractsClientClientAuthenticationSettingsResponseModel {
  platform?: FanguardApiContractsClientClientAuthenticationPlatformEnum;
  domain?: string | null;
  clientId?: string | null;
  managementClientId?: string | null;
  managementApiAudience?: string | null;
}

export interface FanguardApiContractsClientClientCreateRequestModel {
  /**
   * @minLength 1
   * @pattern ^[a-zA-Z0-9-_!]*$
   */
  id: string;
  /** @minLength 1 */
  name: string;
  domainSlug?: string | null;
  licensedFor?: FanguardApiContractsClientClientModelLicenseTypeEnum[] | null;
}

export interface FanguardApiContractsClientClientExpirationSettingsModel {
  /** @format int32 */
  purgeInactivePersonsAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireMatchedTicketingAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireMatchedAccessControlAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireMatchedAgeVerificationAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireMatchedOrderFulfillmentAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireMatchedCredentialingAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireUnmatchedTicketingAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireUnmatchedAccessControlAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireUnmatchedAgeVerificationAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireUnmatchedOrderFulfillmentAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireUnmatchedCredentialingAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireAlertsAfterDays?: number | null;
  /**
   * @format int32
   * @min 120
   * @max 365
   */
  expireEventsAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireMatchedEnrollmentCheckAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireUnmatchedEnrollmentCheckAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireMatchedDayPassAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireUnmatchedDayPassAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireMatchedRemoteTicketingAfterDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 365
   */
  expireUnmatchedRemoteTicketingAfterDays?: number | null;
}

export interface FanguardApiContractsClientClientIntegrationSettingsModel {
  ticketing?: FanguardApiContractsClientTicketingIntegrationSettingsModel;
}

export interface FanguardApiContractsClientClientIntegrationSettingsResponseModel {
  ticketing?: FanguardApiContractsClientTicketingIntegrationSettingsModel;
}

/** @format int32 */
export enum FanguardApiContractsClientClientModelLicenseTypeEnum {
  accessControl,
  securityPositive,
  securityNegative,
  vip,
  ticketmaster,
}

export type FanguardApiContractsClientClientModelLicenseTypeEnumKeys =
  keyof typeof FanguardApiContractsClientClientModelLicenseTypeEnum;

export interface FanguardApiContractsClientClientResponseDetailModel {
  ageConfirmationEnabled?: boolean | null;
  id?: string | null;
  name?: string | null;
  domainSlug?: string | null;
  embedderName?: string | null;
  nextEmbedderName?: string | null;
  /** @format int32 */
  facilityCode?: number | null;
  /** @format double */
  alertThreshold?: number;
  /** @format int32 */
  expireAlertsAfterDays?: number | null;
  /** @format int32 */
  expireDecisionsAfterDays?: number | null;
  /** @format int32 */
  expireTicketingDataAfterDays?: number | null;
  saltBaseUri?: string | null;
  saltUsername?: string | null;
  onDemandQueueOverride?: string | null;
  /** @format int32 */
  purgeInactivePersonsAfterDays?: number | null;
  /** @format date-time */
  wipeOn?: string | null;
  suspendedBy?: string | null;
  status?: string | null;
  licensedFor?: FanguardApiContractsClientClientModelLicenseTypeEnumKeys[] | null;
  /** @format int32 */
  wipeInDays?: number | null;
  kioskInstructions?: string | null;
  kioskClientImageUrl?: string | null;
  integrationSettings?: FanguardApiContractsClientClientIntegrationSettingsResponseModel;
  connections?: FanguardApiContractsClientIConnectionModel[] | null;
  sensorDefaults?: FanguardApiContractsClientClientSensorDefaultSettingsModel;
  expirationSettings?: FanguardApiContractsClientClientExpirationSettingsModel;
  authenticationSettings?: FanguardApiContractsClientClientAuthenticationSettingsResponseModel;
}

export interface FanguardApiContractsClientClientResponseSummaryModel {
  id?: string | null;
  name?: string | null;
  licensedFor?: FanguardApiContractsClientClientModelLicenseTypeEnumKeys[] | null;
  /** @format date-time */
  wipeOn?: string | null;
  status?: string | null;
  /** @format int32 */
  wipeInDays?: number | null;
}

export interface FanguardApiContractsClientClientSensorDefaultSettingsModel {
  crowdCountThresholds?: number[] | null;
  kiosk?: FanguardApiContractsClientKioskConfigurationModel;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  negativeAlertThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  positiveAlertThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  negativeDiagnosticAlertThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  positiveDiagnosticAlertThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  initialBatchAcceptanceThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  initialBatchRejectionThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  additionalBatchAcceptanceThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  additionalBatchRejectionThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  detectionThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  blackhawkInitialBatchAcceptanceThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  blackhawkInitialBatchRejectionThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  blackhawkAdditionalBatchAcceptanceThreshold?: number | null;
  /**
   * @format double
   * @min 0
   * @max 1
   */
  blackhawkAdditionalBatchRejectionThreshold?: number | null;
  /**
   * @format int32
   * @min 5
   * @max 100
   */
  blackhawkLowBatteryThreshold?: number | null;
  enableZmqInterface?: boolean | null;
  enableTapToStart?: boolean | null;
}

export interface FanguardApiContractsClientClientUpdateRequestModel {
  ageConfirmationEnabled?: boolean | null;
  id?: string | null;
  name?: string | null;
  domainSlug?: string | null;
  /** @format double */
  alertThreshold?: number | null;
  /**
   * @format int32
   * @min 30
   * @max 365
   */
  expireAlertsAfterDays?: number | null;
  /**
   * @format int32
   * @min 30
   * @max 365
   */
  expireDecisionsAfterDays?: number | null;
  /**
   * @format int32
   * @min 30
   * @max 365
   */
  expireTicketingDataAfterDays?: number | null;
  /** @format int32 */
  purgeInactivePersonsAfterDays?: number | null;
  expirationSettings?: FanguardApiContractsClientClientExpirationSettingsModel;
  saltBaseUri?: string | null;
  saltUsername?: string | null;
  saltPassword?: string | null;
  onDemandQueueOverride?: string | null;
  unsuspend?: boolean | null;
  licensedFor?: FanguardApiContractsClientClientModelLicenseTypeEnumKeys[] | null;
  sensorDefaults?: FanguardApiContractsClientClientSensorDefaultSettingsModel;
  integrationSettings?: FanguardApiContractsClientClientIntegrationSettingsModel;
  authenticationSettings?: FanguardApiContractsClientClientAuthenticationSettingsModel;
}

export interface FanguardApiContractsClientConnectionRequestModel {
  id?: string | null;
  name: string;
  connectionType: FanguardApiContractsClientConnectionTypeModelEnumKeys;
  connectionTypeDetail: FanguardApiContractsClientConnectionTypeDetailModelEnumKeys;
  isDefaultForConnectionType?: boolean;
}

export interface FanguardApiContractsClientConnectionTicketingRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  autoRedeemEnabled: boolean;
}

export interface FanguardApiContractsClientFortressConnectionRequestModel extends FanguardApiContractsClientConnectionTicketingRequestModel {
  apiUrl: string;
  username: string;
  password?: string;
}

export interface FanguardApiContractsClientProVenueConnectionRequestModel extends FanguardApiContractsClientConnectionTicketingRequestModel {
  clientId?: string;
  clientSecret?: string;
  host: string;
}

export interface FanguardApiContractsClientTicketmasterIatsConnectionRequestModel extends FanguardApiContractsClientConnectionTicketingRequestModel {
  protocolVersion?: string;
  eventsImportEnabled?: boolean;
  host?: string;
  dsn?: string;
  siteId?: string;
  clientId?: string;
  secretKey?: string;
  apiKey?: string;
  visualPresets?: string;
  eventFilter?: string;
}

export interface FanguardApiContractsClientTicketmasterMicroserviceConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  eventsImportEnabled?: boolean;
  host?: string;
  dsn?: string;
  siteId?: string;
  clientId?: string;
  secretKey?: string;
  apiKey?: string;
  visualPresets?: string;
  eventFilter?: string;
}

export interface FanguardApiContractsClientCustomConnectionRequestModel extends FanguardApiContractsClientConnectionTicketingRequestModel {
  retrieveTicketsWebhookUrl: string;
  retrieveTimeout: number;
  scanTicketsWebhookUrl: string;
  scanTimeout: number;
}

/** Vivenu ticketing connection - add to backend swagger and regenerate to replace */
export interface FanguardApiContractsClientVivenuConnectionRequestModel extends FanguardApiContractsClientConnectionTicketingRequestModel {
  eventsImportEnabled?: boolean;
  host: string;
  sellerId: string;
  apiKey?: string;
}

export interface FanguardApiContractsClientPaciolanConnectionRequestModel extends FanguardApiContractsClientConnectionTicketingRequestModel {
  apiUrl: string;
  authorizationKey?: string;
  dataAccountId: string;
}

export interface FanguardApiContractsClientAiFiConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  apiUrl: string;
  token: string;
}

export interface FanguardApiContractsClientLavaMashginConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  lavaBaseUrl: string;
  lavaAuthToken: string;
}

export interface FanguardApiContractsClientLavaTapin2ConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  lavaBaseUrl: string;
  lavaAuthToken: string;
  tapin2BaseUrl: string;
}

export interface FanguardApiContractsClientVenuetizeConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  embedUrl: string;
  apiKey: string;
  clientId: string;
  clientSecret: string;
}

export interface FanguardApiContractsClientAiFiFortressConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  apiUrl: string;
  username: string;
  password?: string;
}

export interface FanguardApiContractsClientZippinConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  providerId: string;
  serviceKeyIds?: string[];
  sendEmails?: boolean;
}

export interface FanguardApiContractsClientGlobalPaymentsConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  merchantKey: string;
  merchantName: string;
  merchantSiteId: string;
  name: string;
  webApiKey: string;
}

export interface FanguardApiContractsClientFiservConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  merchantId: string;
  terminalId: string;
  apiKey: string;
  apiSecret: string;
  hostUrl: string;
}

export interface FanguardApiContractsClientIdMissionV2ConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  apiKey: string;
  apiSecret: string;
  username: string;
  password: string;
  merchantId: string;
  requireBarcodeVerificationForLicences: boolean;
}

export interface FanguardApiContractsClientIdMissionV3ConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  clientId: string;
  clientSecret: string;
  username: string;
  password: string;
  merchantId: string;
}

export interface FanguardApiContractsClientAxsConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  axsClientId: string;
  clientId: string;
  clientSecret: string;
}

export interface FanguardApiContractsClientSeatGeekOAuthConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  clientId: string;
  secret: string;
  teamSlug: string;
}

export interface FanguardApiContractsClientAccessControlCustomFormatRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  specification?: string[];
}

export interface FanguardApiContractsClientAccreditConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  apiUrl: string;
  username: string;
  password?: string;
  importContacts?: boolean;
}

export interface FanguardApiContractsClientCventConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  apiUrl: string;
  clientId: string;
  clientSecret?: string;
  eventId: string;
}

export interface FanguardApiContractsClientRainFocusConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  apiUrl: string;
  apiToken?: string;
}

export interface FanguardApiContractsClientCredentialingCustomConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  interactionWebhookUrl: string;
  printerWebhookUrl?: string;
  credentialingAreaWebhookUrl?: string;
  timeout: number;
  linkedAccountIdSources?: string[];
}

export interface FanguardApiContractsClientNotificationInteractionConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  notificationWebhookUrl: string;
  timeout: number;
  linkedAccountIdSources: string[];
}

export interface FanguardApiContractsClientNotificationEnrollmentConnectionRequestModel extends FanguardApiContractsClientConnectionRequestModel {
  notificationWebhookUrl: string;
  timeout: number;
}

export enum FanguardApiContractsClientConnectionTypeDetailModelEnum {
  TicketingTicketmasterIats,
  CredentialingAccredit,
  OrderFulfillmentLavaTapin2,
  OrderFulfillmentVenuetize,
  OrderFulfillmentLavaMashgin,
  OrderFulfillmentAiFi,
  OrderFulfillmentFortressAiFi,
  OrderFulfillmentCustom,
  OrderFulfillmentZippin,
  AuthenticationSeatGeekOAuth,
  TicketingMock,
  TicketingTicketmasterMicroservice,
  TicketingProVenue,
  TicketingFortress,
  TicketingAxs,
  AuthenticationEmailVerification,
  AuthenticationTicketmasterOAuth,
  AuthenticationAxs,
  AgeVerificationIdMissionV2,
  AgeVerificationIdMissionV3,
  CredentialingRainFocus,
  CredentialingMock,
  AccessControlCustomFormat,
  WalletGlobalPayments,
  AuthenticationProVenue,
  CredentialingCvent,
  AuthenticationCvent,
  CredentialingCustom,
  TicketingCustom,
  TicketingVivenu,
  TicketingPaciolan,
  NotificationInteraction,
  NotificationEnrollment,
  WalletFiserv,
}

export type FanguardApiContractsClientConnectionTypeDetailModelEnumKeys =
  keyof typeof FanguardApiContractsClientConnectionTypeDetailModelEnum;

/** @format int32 */
export enum FanguardApiContractsClientConnectionTypeModelEnum {
  Ticketing,
  Credentialing,
  OrderFulfillment,
  Authentication,
  AgeVerification,
  AccessControl,
  Wallet,
  Notification,
}

export type FanguardApiContractsClientConnectionTypeModelEnumKeys =
  keyof typeof FanguardApiContractsClientConnectionTypeModelEnum;

export type FanguardApiContractsClientConnectionRequestModelMerged =
  | FanguardApiContractsClientConnectionRequestModel
  | FanguardApiContractsClientFortressConnectionRequestModel
  | FanguardApiContractsClientProVenueConnectionRequestModel
  | FanguardApiContractsClientTicketmasterIatsConnectionRequestModel
  | FanguardApiContractsClientCustomConnectionRequestModel
  | FanguardApiContractsClientAiFiConnectionRequestModel
  | FanguardApiContractsClientLavaMashginConnectionRequestModel
  | FanguardApiContractsClientLavaTapin2ConnectionRequestModel
  | FanguardApiContractsClientVenuetizeConnectionRequestModel
  | FanguardApiContractsClientAiFiFortressConnectionRequestModel
  | FanguardApiContractsClientZippinConnectionRequestModel
  | FanguardApiContractsClientGlobalPaymentsConnectionRequestModel
  | FanguardApiContractsClientFiservConnectionRequestModel
  | FanguardApiContractsClientIdMissionV2ConnectionRequestModel
  | FanguardApiContractsClientIdMissionV3ConnectionRequestModel
  | FanguardApiContractsClientAxsConnectionRequestModel
  | FanguardApiContractsClientSeatGeekOAuthConnectionRequestModel
  | FanguardApiContractsClientAccessControlCustomFormatRequestModel
  | FanguardApiContractsClientVivenuConnectionRequestModel
  | FanguardApiContractsClientPaciolanConnectionRequestModel;

export interface FanguardApiContractsClientContentModel {
  introduction?: FanguardApiContractsClientIntroductionModel;
  registration?: FanguardApiContractsClientRegistrationModel;
  photoUpload?: FanguardApiContractsClientPhotoUploadModel;
}

export interface FanguardApiContractsClientCreateEventRequestModel {
  id?: string | null;
  /** @minLength 1 */
  name: string;
  description?: string | null;
  /** @format date-time */
  startsOn: string;
  /** @format date-time */
  endsOn: string;
  imageId?: string | null;
  image?: string | null;
  source?: string | null;
  externalData?: Record<string, string>;
  tmEventId?: string | null;
  tmEventName?: string | null;
  /** @minLength 1 */
  venueId: string;
}

export interface FanguardApiContractsClientDeleteAssetRequestModel {
  id?: string | null;
}

export interface FanguardApiContractsClientDesignModel {
  introduction?: FanguardApiContractsClientSiteIntroductionModel;
  smallLogoImageId?: string | null;
  smallLogoImageUrl?: string | null;
  largeLogoImageId?: string | null;
  largeLogoImageUrl?: string | null;
  backgroundImageId?: string | null;
  backgroundImageUrl?: string | null;
  campaignPageDescriptionHtml?: string | null;
  campaignPageTitle?: string | null;
  styleSheet?: string | null;
  styleSheetId?: string | null;
  styleSheetUrl?: string | null;
  privacyPolicyHtml?: string | null;
  privacyPolicyAgreementText?: string | null;
  footerHtml?: string | null;
  useWicketFooter?: boolean | null;
}

export interface FanguardApiContractsClientEditEventRequestModel {
  id?: string | null;
  /** @minLength 1 */
  name: string;
  description?: string | null;
  /** @format date-time */
  startsOn: string;
  /** @format date-time */
  endsOn: string;
  imageId?: string | null;
  image?: string | null;
  source?: string | null;
  externalData?: Record<string, string>;
  tmEventId?: string | null;
  tmEventName?: string | null;
}

export interface FanguardApiContractsClientEmailTemplateCreateRequestModel {
  key?: FanguardApiContractsClientEmailTemplateModelKeyEnum;
  /** @minLength 1 */
  subject: string;
  /** @minLength 1 */
  fromEmailAddress: string;
  textTemplate?: string | null;
  htmlTemplate?: string | null;
  /** @format int32 */
  version?: number;
  active?: boolean;
}

export enum FanguardApiContractsClientEmailTemplateModelKeyEnum {
  NewAccount = 'NewAccount',
  ResetPassword = 'ResetPassword',
  UploadPhoto = 'UploadPhoto',
  JobProgress = 'JobProgress',
  PreEvent = 'PreEvent',
  RegistrationReminderMissingPhotos = 'RegistrationReminderMissingPhotos',
  EnrollmentComplete = 'EnrollmentComplete',
  EmailVerification = 'EmailVerification',
  LinkAccount = 'LinkAccount',
  Otp = 'Otp',
  RequestEnrollment = 'RequestEnrollment',
  IncompleteEnrollmentReminder = 'IncompleteEnrollmentReminder',
}

export interface FanguardApiContractsClientEmailTemplateModel {
  id?: string | null;
  client?: string | null;
  key?: FanguardApiContractsClientEmailTemplateModelKeyEnum;
  subject?: string | null;
  fromEmailAddress?: string | null;
  textTemplate?: string | null;
  htmlTemplate?: string | null;
  /** @format int32 */
  version?: number;
  active?: boolean;
  /** @format int32 */
  reminderDelay?: number;
}

export interface FanguardApiContractsClientEmailTemplateUpdateRequestModel {
  /** @minLength 1 */
  subject: string;
  /** @minLength 1 */
  fromEmailAddress: string;
  textTemplate?: string | null;
  htmlTemplate?: string | null;
  /** @format int32 */
  version?: number;
  active?: boolean | null;
  /** @format int32 */
  reminderDelay?: number | null;
}

export interface FanguardApiContractsClientEventDetailModel {
  id?: string | null;
  /** @minLength 1 */
  name: string;
  code?: string | null;
  description?: string | null;
  source?: string | null;
  imageId?: string | null;
  imageUrl?: string | null;
  venue?: FanguardApiContractsClientVenueBaseModel;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  startsOn?: string | null;
  /** @format date-time */
  endsOn?: string | null;
  externalData?: Record<string, string>;
  active?: boolean;
  readOnly?: boolean;
  /** @format date-time */
  scanStartsOn?: string | null;
  /** @format date-time */
  scanEndsOn?: string | null;
  hasOverlap?: boolean;
  /** @format date-time */
  sortableStartsOn?: string | null;
  exterior?: FanguardApiContractsClientTicketingScanFacilityModel;
  interior?: FanguardApiContractsClientTicketingScanFacilityModel;
  tmEventName?: string | null;
}

export interface FanguardApiContractsClientIConnectionModel {
  id?: string | null;
  name?: string | null;
  apiKey?: string | null;
  clientId?: string | null;
  interfaces?: string[] | null;
  connectionType?: FanguardApiContractsClientConnectionTypeModelEnumKeys;
  connectionTypeDetail?: FanguardApiContractsClientConnectionTypeDetailModelEnumKeys;
  isDefaultForConnectionType?: boolean;
  merchantId?: string | null;
  username?: string | null;
  requireBarcodeVerificationForLicences?: boolean;
}

export interface FanguardApiContractsClientIntroductionModel {
  enabled?: boolean | null;
  marketingInfo?: string | null;
  /** @deprecated */
  tagline?: string | null;
}

export interface FanguardApiContractsClientKioskColorPaletteModel {
  /** @format int32 */
  backgroundImageOpacity?: number | null;
  primaryColor?: string | null;
  secondaryColor?: string | null;
  numberColor?: string | null;
  standard?: FanguardApiContractsClientKioskScreenColorsModel;
  knownPersonAccepted?: FanguardApiContractsClientKioskScreenColorsModel;
  knownPersonDenied?: FanguardApiContractsClientKioskScreenColorsModel;
  unknownPerson?: FanguardApiContractsClientKioskScreenColorsModel;
}

export interface FanguardApiContractsClientKioskConfigurationModel {
  exitPassword?: string | null;
  viewfinderEnabled?: boolean | null;
  scanningMethod?: FanguardApiContractsClientScanningMethodModelEnum;
  enableZmqInterface?: boolean | null;
  displayPoweredByLogo?: boolean | null;
  design?: Record<string, FanguardApiContractsClientKioskDesignModel>;
  messages?: FanguardApiContractsClientKioskMessagesModel;
}

export interface FanguardApiContractsClientKioskDesignModel {
  images?: Record<string, FanguardApiContractsClientKioskImageModel>;
  colors?: FanguardApiContractsClientKioskColorPaletteModel;
}

export interface FanguardApiContractsClientKioskGeneralMessagesModel {
  personNameDisplayTemplate?: string | null;
  entryConfirmation?: string | null;
  entryDenied?: string | null;
}

export interface FanguardApiContractsClientKioskImageModel {
  id?: string | null;
  image?: string | null;
  name?: string | null;
  /** @format int64 */
  size?: number | null;
  /** @format int32 */
  displaySizePercentage?: number | null;
  url?: string | null;
  delete?: boolean;
}

export interface FanguardApiContractsClientKioskIntroductionMessagesModel {
  message?: string | null;
  title?: string | null;
}

export interface FanguardApiContractsClientKioskMessagesModel {
  general?: FanguardApiContractsClientKioskGeneralMessagesModel;
  introduction?: FanguardApiContractsClientKioskIntroductionMessagesModel;
}

export interface FanguardApiContractsClientKioskScreenColorsModel {
  backgroundColor?: string | null;
  backgroundColorOverlay?: string | null;
  /** @format double */
  backgroundColorOpacity?: number | null;
  textColor?: string | null;
  showBackgroundImage?: boolean | null;
}

export interface FanguardApiContractsClientPhotoUploadModel {
  instructions?: string | null;
  tip?: string | null;
  success?: string | null;
}

export interface FanguardApiContractsClientPointModel {
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
}

export interface FanguardApiContractsClientRegistrationModel {
  confirmation?: string | null;
  callToActionButtonTitle?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsClientScanningMethodModelEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

export interface FanguardApiContractsClientSendTestEmailRequestModel {
  emailAddresses?: string | null;
}

export interface FanguardApiContractsClientSensorPlacementRequestModel {
  sensorId?: string | null;
  /** @minLength 1 */
  placementName: string;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
}

export interface FanguardApiContractsClientSiteCreateRequestModel {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  pathSegment: string;
}

export interface FanguardApiContractsClientSiteDetailModel {
  id?: string | null;
  name?: string | null;
  pathSegment?: string | null;
  logoImageUrl?: string | null;
  client?: string | null;
  design?: FanguardApiContractsClientDesignModel;
  campaigns?: FanguardApiContractsClientCampaignDetailModel[] | null;
  ageConfirmationEnabled?: boolean | null;
  authenticationConnection?: FanguardApiContractsClientIConnectionModel;
  connections?: FanguardApiContractsClientIConnectionModel[] | null;
  requirePersonNames?: boolean;
}

export interface FanguardApiContractsClientSiteIntroductionModel {
  enabled?: boolean | null;
  html?: string | null;
}

export interface FanguardApiContractsClientSiteSummaryModel {
  id?: string | null;
  name?: string | null;
  pathSegment?: string | null;
  logoImageUrl?: string | null;
  client?: string | null;
}

export interface FanguardApiContractsClientSiteUpdateRequestModel {
  name?: string | null;
  pathSegment?: string | null;
  design?: FanguardApiContractsClientDesignModel;
  authenticationConnectionId?: string | null;
  requirePersonNames?: boolean;
}

export interface FanguardApiContractsClientStartNetworkSwitchRequestModel {
  nextNetworkName?: string | null;
}

export interface FanguardApiContractsClientTestWebhookConnection {
  connectionId?: string | null;
  webhookTestType?: FanguardApiContractsClientWebhookTestType | string;
  webhookUrl?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsClientTicketingIntegrationPlatformModelEnum {
  Unconfigured,
  TicketingTicketmasterIats,
  TicketingTicketmasterMicroservice,
  TicketingMock,
  TicketingProVenue,
  TicketingFortress,
  TicketingAxs,
  TicketingCustom,
  TicketingVivenu,
  TicketingPaciolan,
}

export type FanguardApiContractsClientTicketingIntegrationPlatformModelEnumKeys =
  keyof typeof FanguardApiContractsClientTicketingIntegrationPlatformModelEnum;

export enum FanguardApiContractsClientOrderFulfillmentPlatformModelEnum {
  OrderFulfillmentLavaTapin2,
  OrderFulfillmentVenuetize,
  OrderFulfillmentLavaMashgin,
  OrderFulfillmentAiFi,
  OrderFulfillmentFortressAiFi,
  OrderFulfillmentCustom,
  OrderFulfillmentZippin,
}

export type FanguardApiContractsClientOrderFulfillmentPlatformModelEnumKeys =
  keyof typeof FanguardApiContractsClientOrderFulfillmentPlatformModelEnum;

export enum FanguardApiContractsClientWalletPlatformModelEnum {
  WalletGlobalPayments,
  WalletFiserv,
}

export type FanguardApiContractsClientWalletPlatformModelEnumKeys =
  keyof typeof FanguardApiContractsClientWalletPlatformModelEnum;

export enum FanguardApiContractsClientIdentityVerificationPlatformModelEnum {
  AgeVerificationIdMissionV2,
  AgeVerificationIdMissionV3,
}

export type FanguardApiContractsClientIdentityVerificationPlatformModelEnumKeys =
  keyof typeof FanguardApiContractsClientIdentityVerificationPlatformModelEnum;

export enum FanguardApiContractsClientAuthenticationPlatformModelEnum {
  AuthenticationAxs,
  AuthenticationCvent,
  AuthenticationEmailVerification,
  AuthenticationSeatGeekOAuth,
  AuthenticationTicketmasterOAuth,
  AuthenticationProVenue,
}

export type FanguardApiContractsClientAuthenticationPlatformModelEnumKeys =
  keyof typeof FanguardApiContractsClientAuthenticationPlatformModelEnum;

export enum FanguardApiContractsClientAccessControlPlatformModelEnum {
  AccessControlCustomFormat,
}

export type FanguardApiContractsClientAccessControlPlatformModelEnumKeys =
  keyof typeof FanguardApiContractsClientAccessControlPlatformModelEnum;

export enum FanguardApiContractsClientCredentialingPlatformModelEnum {
  CredentialingAccredit,
  CredentialingCvent,
  CredentialingCustom,
  CredentialingMock,
  CredentialingRainFocus,
}

export type FanguardApiContractsClientCredentialingPlatformModelEnumKeys =
  keyof typeof FanguardApiContractsClientCredentialingPlatformModelEnum;

export enum FanguardApiContractsClientNotificationPlatformModelEnum {
  NotificationInteraction,
  NotificationEnrollment,
}

export type FanguardApiContractsClientNotificationPlatformModelEnumKeys =
  keyof typeof FanguardApiContractsClientNotificationPlatformModelEnum;

export interface FanguardApiContractsClientTicketingIntegrationSettingsModel {
  ageConfirmationEnabled?: boolean | null;
}

export interface FanguardApiContractsClientTicketingScanFacilityModel {
  code?: string | null;
  exitScanEnabled?: boolean;
  /** @format int32 */
  validScansPerDay?: number;
  /** @format int32 */
  validScansPerEvent?: number;
}

export interface FanguardApiContractsClientUploadAssetRequestModel {
  name?: string | null;
  file?: string | null;
  contentType?: string | null;
}

export interface FanguardApiContractsClientVenueBaseModel {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  city?: string | null;
  state?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  stageCoordinates?: FanguardApiContractsClientPointModel[] | null;
  source?: string | null;
  timeZone?: string | null;
  credentialAreaCodePrefix?: string | null;
}

export interface FanguardApiContractsClientExternalDataModel {
  'tm-presenceVenueId'?: string | null;
}

export interface FanguardApiContractsClientVenueDetailModel {
  id: string;
  name: string;
  description?: string;
  city?: string;
  state?: string;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  stageCoordinates?: FanguardApiContractsClientPointModel[];
  source?: string;
  timeZone?: string;
  credentialAreaCodePrefix?: string;
  imageId?: string;
  imageUrl?: string;
  events?: FanguardApiContractsClientEventDetailModel[];
  nextEvent?: FanguardApiContractsClientEventDetailModel;
  sensorPlacements?: FanguardApiContractsSensorSensorModel[];
  externalData?: FanguardApiContractsClientExternalDataModel;
  tmVenueId?: string;
  facilityCodes?: number[];
}

export interface FanguardApiContractsClientVenueRequestModel {
  id?: string | null;
  name: string | null;
  description?: string | null;
  city?: string | null;
  state?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  stageCoordinates?: FanguardApiContractsClientPointModel[] | null;
  source?: string | null;
  timeZone?: string | null;
  credentialAreaCodePrefix?: string | null;
  imageId?: string | null;
  image?: string | null;
  imageUrl?: string | null;
  externalData?: FanguardApiContractsClientExternalDataModel;
  tmVenueId?: string | null;
  facilityCodes?: number[] | null;
}

export interface FanguardApiContractsClientVenueSummaryModel {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  city?: string | null;
  state?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  stageCoordinates?: FanguardApiContractsClientPointModel[] | null;
  source?: string | null;
  timeZone?: string | null;
  credentialAreaCodePrefix?: string | null;
  imageId?: string | null;
  imageUrl?: string | null;
  events?: FanguardApiContractsClientEventDetailModel[] | null;
  nextEvent?: FanguardApiContractsClientEventDetailModel;
}

/** @format int32 */
export enum FanguardApiContractsClientWebhookTestType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

export interface FanguardApiContractsConfigModel {
  currentVenue?: FanguardApiContractsClientVenueSummaryModel;
  defaultVenue?: FanguardApiContractsClientVenueSummaryModel;
  unsignedAgreements?: FanguardApiContractsClientAgreementModel[] | null;
  supportedMobileVersion?: string | null;
  clientLicenses?: FanguardApiContractsClientClientModelLicenseTypeEnum[] | null;
  ticketingPlatform?: FanguardApiContractsClientTicketingIntegrationPlatformModelEnumKeys;
}

export interface FanguardApiContractsControllerControllerBeatModel {
  status?: FanguardApiContractsBoxDeviceDetailStatusEnum;
  softwareVersion?: string | null;
  metrics?: Record<string, number | null>;
  /** @format date-time */
  timestamp?: string;
  /** @format date-time */
  boxTimestamp?: string;
}

/** @format int32 */
export enum FanguardApiContractsControllerControllerCardFormatModelEnum {
  Std26bit = 0,
  H10304,
  Custom = 100,
}

export type FanguardApiContractsControllerControllerCardFormatModelEnumKeys =
  keyof typeof FanguardApiContractsControllerControllerCardFormatModelEnum;

export interface FanguardApiContractsControllerControllerModel {
  id?: string | null;
  name?: string | null;
  venueId?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  status?: string | null;
  latestBeat?: FanguardApiContractsControllerControllerBeatModel;
  minionName?: string | null;
  ipAddress?: string | null;
  ports?: FanguardApiContractsControllerControllerPortModel[] | null;
  sensorGroupId?: string | null;
  watchlists?: FanguardApiContractsSensorSensorWatchlistModel[] | null;
  snapshotUpdatedOn?: string | null;
  areSnapshotsEnabled?: boolean | null;
  snapshotUrl?: string | null;
}

export interface FanguardApiContractsControllerControllerPortModel {
  /** @format int32 */
  portNumber?: number;
  cardFormat?: FanguardApiContractsControllerControllerCardFormatModelEnumKeys;
  customFormatConnectionId?: string | null;
  protocol?: FanguardApiContractsControllerPanelInterfaceProtocolModelEnumKeys;
  sensors?: string[] | null;
}

export interface FanguardApiContractsControllerControllerPortSensorAssignmentRequestModel {
  sensorId?: string | null;
}

export interface FanguardApiContractsControllerControllerPortTestRequestModel {
  /** @format int32 */
  port?: number;
  cardFormat?: FanguardApiContractsControllerControllerCardFormatModelEnumKeys;
  customFormatConnectionId?: string | null;
  protocol?: FanguardApiContractsControllerPanelInterfaceProtocolModelEnumKeys;
  credential?: string | null;
}

export interface FanguardApiContractsControllerControllerPortUpdateRequestModel {
  /** @format int32 */
  portNumber?: number;
  cardFormat?: FanguardApiContractsControllerControllerCardFormatModelEnumKeys;
  customFormatConnectionId?: string | null;
  protocol?: FanguardApiContractsControllerPanelInterfaceProtocolModelEnumKeys;
}

export interface FanguardApiContractsControllerControllerUpdateRequestModel {
  name?: string | null;
  minionName?: string | null;
  venueId?: string | null;
  ipAddress?: string | null;
  ports?: FanguardApiContractsControllerControllerPortUpdateRequestModel[] | null;
}

/** @format int32 */
export enum FanguardApiContractsControllerPanelInterfaceProtocolModelEnum {
  Wiegand,
}

export type FanguardApiContractsControllerPanelInterfaceProtocolModelEnumKeys =
  keyof typeof FanguardApiContractsControllerPanelInterfaceProtocolModelEnum;

/** @format int32 */
export enum FanguardApiContractsDecisionDecisionStatusEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

export interface FanguardApiContractsDecisionDecisionSummaryModel {
  id?: string | null;
  granted?: boolean;
  grantStatus?: FanguardApiContractsDecisionInteractionGrantStatus;
  overrideReason?: string | null;
  overrideReasonDetail?: string | null;
  /** @format double */
  spoofProbability?: number | null;
  spoofAlgorithmName?: string | null;
  spoofAlgorithmVersion?: string | null;
  /** @format date-time */
  createdOn?: string;
  createdBy?: string | null;
  client?: string | null;
  status?: FanguardApiContractsDecisionDecisionStatusEnum;
  sensorId?: string | null;
  sensorName?: string | null;
  sensorPlacementName?: string | null;
  sensorMode?: string | null;
  eventId?: string | null;
  eventName?: string | null;
  venueId?: string | null;
  venueName?: string | null;
  source?: string | null;
  affirmed?: boolean;
  detectedImageId?: string | null;
  contextImageId?: string | null;
  /** @format date-time */
  detectedOn?: string;
  /** @format date-time */
  matchedOn?: string | null;
  personId?: string | null;
  personFirstName?: string | null;
  personLastName?: string | null;
  personPhotoId?: string | null;
  watchlistId?: string | null;
  watchlistName?: string | null;
  /** @format float */
  matchConfidenceScore?: number;
  /** @format double */
  similarity?: number;
  similarityText?: string | null;
  trackedFaceId?: string | null;
  detectedImageUrl?: string | null;
  contextImageUrl?: string | null;
  personPhotoImageUrl?: string | null;
  primaryDetectionId?: string | null;
}

export interface FanguardApiContractsDecisionDetectionProcessorResultModel {
  id?: string | null;
  granted?: boolean;
  overrideReason?: string | null;
  overrideReasonDetail?: string | null;
  displayMessage?: string | null;
  status?: FanguardApiContractsDecisionDecisionStatusEnum;
  /** @format date-time */
  createdOn?: string;
}

/** @format int32 */
export type FanguardApiContractsDecisionInteractionGrantStatus = 'Denied' | 'Partial' | 'Granted' | 'Pending';

export interface FanguardApiContractsDecisionTicketDecisionSummaryModel {
  id?: string | null;
  granted?: boolean;
  grantStatus?: FanguardApiContractsDecisionInteractionGrantStatus;
  overrideReason?: string | null;
  overrideReasonDetail?: string | null;
  /** @format double */
  spoofProbability?: number | null;
  spoofAlgorithmName?: string | null;
  spoofAlgorithmVersion?: string | null;
  /** @format date-time */
  createdOn?: string;
  createdBy?: string | null;
  client?: string | null;
  status?: FanguardApiContractsDecisionDecisionStatusEnum;
  sensorId?: string | null;
  sensorName?: string | null;
  sensorPlacementName?: string | null;
  sensorMode?: string | null;
  eventId?: string | null;
  eventName?: string | null;
  venueId?: string | null;
  venueName?: string | null;
  source?: string | null;
  affirmed?: boolean;
  detectedImageId?: string | null;
  contextImageId?: string | null;
  /** @format date-time */
  detectedOn?: string;
  /** @format date-time */
  matchedOn?: string | null;
  personId?: string | null;
  personFirstName?: string | null;
  personLastName?: string | null;
  personPhotoId?: string | null;
  watchlistId?: string | null;
  watchlistName?: string | null;
  /** @format float */
  matchConfidenceScore?: number;
  /** @format double */
  similarity?: number;
  similarityText?: string | null;
  trackedFaceId?: string | null;
  detectedImageUrl?: string | null;
  contextImageUrl?: string | null;
  personPhotoImageUrl?: string | null;
  primaryDetectionId?: string | null;
  ticketScans?: FanguardApiContractsTicketTicketScanSummary[] | null;
}

/** @format int32 */
export enum FanguardApiContractsDetectionDetectionResultEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
}

/** @format int32 */
export enum FanguardApiContractsDetectionDetectionTypeEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
}

export interface FanguardApiContractsDetectionRemoteDetectionCreateRequest {
  /** @minLength 1 */
  location: string;
  /** @format int32 */
  minimumAge?: number | null;
  paymentExpected?: boolean;
}

export interface FanguardApiContractsDetectionRemoteDetectionResponse {
  interactionId?: string | null;
  ageVerified?: boolean | null;
  paymentAccountId?: string | null;
  granted?: boolean;
  resultDetail?: string | null;
}

export interface FanguardApiContractsDetectionUnifiedDetectionCreateRequest {
  detectionType?: FanguardApiContractsDetectionDetectionTypeEnum;
  /** @pattern ^[0-9a-fA-F]{24}$ */
  sensorId?: string | null;
  /** @pattern ^[0-9a-fA-F]{24}$ */
  personId?: string | null;
  /** @pattern ^[0-9a-fA-F]{24}$ */
  personPhotoId?: string | null;
  /** @pattern ^[0-9a-fA-F]{24}$ */
  watchlistId?: string | null;
  /** @format float */
  businessConfidence?: number | null;
  /** @format float */
  confidence?: number | null;
  /** @format float */
  similarity?: number;
  /** @format float */
  spoofProbability?: number | null;
  spoofAlgorithmName?: string | null;
  spoofAlgorithmVersion?: string | null;
  result?: FanguardApiContractsDetectionDetectionResultEnum;
  contextImageData?: string | null;
  detectedImageData?: string | null;
  /** @format date-time */
  detectedOn?: string;
  /** @format date-time */
  matchedOn?: string;
  /** @format date-time */
  sentOn?: string;
  /** @format date-time */
  trackingStartedOn?: string;
  /** @format date-time */
  identificationStartedOn?: string;
  /** @format date-time */
  classificationStartedOn?: string;
  isDiagnostic?: boolean;
  /** @format int32 */
  eyeDistance?: number | null;
  faceTrackId?: string | null;
  isContextImageBlurred?: boolean | null;
  ticketProviderAccessToken?: string | null;
  ageVerificationRequested?: boolean;
}

export interface FanguardApiContractsDevicesDeviceModel {
  id?: string | null;
  name?: string | null;
  pairedSensorName?: string | null;
  pairingStatus?: FanguardApiContractsBoxPairingStatusKeys;
  pairingErrorMessage?: string | null;
  venueId?: string | null;
  deviceType?: FanguardApiContractsDevicesDeviceType;
  status?: FanguardApiContractsSensorDeviceStatusEnumKeys;
  isOnline?: boolean;
  snapshotUrl?: string | null;
  placementName?: string | null;
  /** @format int32 */
  batteryLevel?: number | null;
  accessControlMode?: FanguardApiContractsSensorSensorAccessControlModeModelKeys;
  batteryState?: FanguardApiContractsBoxBatteryStateModelEnum;
  deviceDetailStatus?: FanguardApiContractsBoxDeviceDetailStatusEnum;
  softwareVersion?: string | null;
  listStatus?: FanguardApiContractsDevicesListStatus;
  watchlists?: FanguardApiContractsDevicesDeviceWatchlistModel[] | null;
  sensorGroupName?: string | null;
  platform?: FanguardApiContractsSensorSensorModelPlatformEnum;
  reportCategory?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsDevicesDeviceType {
  Value0 = 0,
  Value1 = 1,
}

export interface FanguardApiContractsDevicesDeviceWatchlistModel {
  watchlistId?: string | null;
  watchlistName?: string | null;
  status?: FanguardApiContractsDevicesDeviceWatchlistStatusEnum;
}

/** @format int32 */
export enum FanguardApiContractsDevicesDeviceWatchlistStatusEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum FanguardApiContractsDevicesListStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export interface FanguardApiContractsErrorErrorModel {
  message?: string | null;
  exception?: FanguardApiContractsErrorErrorModelException;
}

export interface FanguardApiContractsErrorErrorModelException {
  type?: string | null;
  data?: Record<string, unknown>;
  source?: string | null;
  innerException?: FanguardApiContractsErrorErrorModelException;
  message?: string | null;
  stackTrace?: string | null;
}

export interface FanguardApiContractsFrNetworkFrNetworkModel {
  id?: string | null;
  name?: string | null;
}

export interface FanguardApiContractsHostHostModel {
  id?: string | null;
  status?: FanguardApiContractsHostHostStatusModelEnum;
  product?: FanguardApiContractsHostHostProductModelEnum;
}

/** @format int32 */
export enum FanguardApiContractsHostHostProductModelEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export interface FanguardApiContractsHostHostProvisionRequestModel {
  hostId?: string | null;
  client?: string | null;
  sensorName?: string | null;
  product?: FanguardApiContractsHostProductTypeEnum;
  venueId?: string | null;
}

export interface FanguardApiContractsProvisionSensorRequestModel {
  client: string;
  code: string;
  name: string;
  venueId?: string | null;
}

export interface FanguardApiContractsProvisionSensorResponseModel {
  provisioningId?: string | null;
  sensorId?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsHostHostStatusModelEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum FanguardApiContractsHostProductTypeEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

export interface FanguardApiContractsIdVerificationStartIdVerificationProcessResponseModel {
  submissionToken?: string | null;
  requireBarcodeVerificationForLicences?: boolean;
}

export interface FanguardApiContractsIdVerificationStartIdVerificationRequestModel {
  /** @minLength 1 */
  siteId: string;
  /** @minLength 1 */
  campaignId: string;
}

/** @format int32 */
export enum FanguardApiContractsInteractionClaimStatus {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum FanguardApiContractsInteractionInteractionAlertTypeModelEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum FanguardApiContractsInteractionInteractionBlockedReasonModelEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export type FanguardApiContractsInteractionInteractionDecisionOperationModel =
  | 'CredentialingScan'
  | 'CredentialingCheckIn';

export interface FanguardApiContractsInteractionInteractionFilterOptionModel {
  default: boolean;
  id: string;
  name: string;
}
export interface FanguardApiContractsInteractionInteractionFilterModel {
  default: boolean;
  displayName?: string | null;
  parameterName?: string | null;
  filterType?: FanguardApiContractsAlertFilterTypeEnumKeys;
  options: FanguardApiContractsInteractionInteractionFilterOptionModel[];
  defaultMax: number;
  defaultMin: number;
  max: number;
  min: number;
  parameterMaxName: string;
  parameterMinName: string;
  shouldPauseLiveUpdating: boolean;
}

/** @format int32 */
export enum FanguardApiContractsInteractionInteractionGrantStatusModelEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export interface FanguardApiContractsInteractionInteractionListModel {
  filters?: FanguardApiContractsInteractionInteractionFilterModel[] | null;
  /** @format int32 */
  count?: number | null;
  interactions?: FanguardApiContractsInteractionInteractionResponseModel[] | null;
}

export interface FanguardApiContractsInteractionInteractionNoteModel {
  id?: string | null;
  text?: string | null;
  createdByName?: string | null;
  createdBy?: string | null;
  /** @format date-time */
  createdOn?: string | null;
}

export interface FanguardApiContractsInteractionInteractionNoteRequestModel {
  id?: string | null;
  type: FanguardApiContractsInteractionInteractionTypeEnum;
  /** @minLength 1 */
  text: string;
}

export interface FanguardApiContractsInteractionInteractionOrderItemResponseModel {
  id?: string | null;
  description?: string | null;
  /** @format int32 */
  quantity?: number;
  /** @format float */
  unitPrice?: number;
  /** @format float */
  totalPrice?: number;
}

export interface FanguardApiContractsInteractionInteractionOrderResponseModel {
  orderNumber?: string | null;
  /** @format date-time */
  orderDate?: string;
  items?: FanguardApiContractsInteractionInteractionOrderItemResponseModel[] | null;
  claimStatus?: FanguardApiContractsInteractionClaimStatus;
  /** @format float */
  totalTax?: number | null;
  /** @format float */
  totalDiscount?: number | null;
  /** @format float */
  subtotalPrice?: number;
  /** @format float */
  totalPrice?: number;
  runningTotal?: number;
  status?: string | null;
}

export interface FanguardApiContractsInteractionInteractionProviderResponseModel {
  code?: string | null;
  text?: string | null;
  error?: string | null;
}

// type sent to the API is based on the enum values, modify with care
export enum FanguardApiContractsInteractionInteractionTypeModelEnum {
  Alert,
  InteractionDecisionAccessControl,
  InteractionDecisionTicketing,
  All,
  Credentialing,
  InteractionDecisionOrderFulfillment,
  AgeVerification,
  EnrollmentCheck,
  DayPass,
  RemoteTicketing,
  InteractionDecisionWebView,
  InteractionDecisionCredentialing,
}

export type FanguardApiContractsInteractionInteractionTypeModelEnumKeys =
  keyof typeof FanguardApiContractsInteractionInteractionTypeModelEnum;

export enum FanguardApiContractsInteractionOverrideReasonDetails {
  DeniedSpoofAttempt = 'deniedspoofattempt',
  DeniedSystemError = 'deniedsystemerror',
  DeniedUnderAge = 'deniedunderage',
  DeniedNoCredential = 'deniednocredential',
  DeniedMultipleCredentials = 'deniedmultiplecredentials',
  DeniedBlur = 'deniedblur',
  DeniedCredential = 'deniedcredential',
  AlreadyCheckedIn = 'alreadycheckedin',
  NoLinkedArea = 'nolinkedarea',
  NoLinkedAccount = 'nolinkedaccount',
  Unknown = 'unknown',
  Error = 'error',
  BadgeNotFound = 'badgenotfound',
  BadgeDeactivated = 'badgedeactivated',
  RegistrationNotFoundAtEvent = 'registrationnotfoundatevent',
  RegistrationNotApproved = 'registrationnotapproved',
  NoPrivileges = 'noprivileges',
  RegistrationSubtypeNotAllowed = 'registrationsubtypenotallowed',
  AreaNotFound = 'areanotfound',
  AreaNotActive = 'areanotactive',
  AreaNoConfigurations = 'areanoconfigurations',
  AlreadyEntered = 'alreadyentered',
  SectionRestriction = 'sectionrestriction',
}

export type FanguardApiContractsInteractionOverrideReasonDetailsKeys =
  keyof typeof FanguardApiContractsInteractionOverrideReasonDetails;

export interface FanguardApiContractsInteractionInteractionResponseModel {
  id?: string | null;
  type?: FanguardApiContractsInteractionInteractionTypeModelEnumKeys | null;
  alertType?: FanguardApiContractsInteractionInteractionAlertTypeModelEnum;
  isAffirmed?: boolean;
  personId?: string | null;
  personName?: string | null;
  sensorId?: string | null;
  sensorName?: string | null;
  sensorContextImageEnabled?: boolean;
  venueId?: string | null;
  watchlistId?: string | null;
  watchlistName?: string | null;
  /** @format double */
  businessConfidence?: number | null;
  /** @format date-time */
  detectedOn?: string;
  /** @format date-time */
  createdOn?: string;
  blockedReason?: FanguardApiContractsInteractionInteractionBlockedReasonModelEnum;
  validationStatus?: FanguardApiContractsInteractionInteractionValidationStatusModelEnumKeys;
  overrideReason?: FanguardApiContractsInteractionOverrideReasonDetails;
  grantStatus?: FanguardApiContractsDecisionInteractionGrantStatus;
  workflowStage?: FanguardApiContractsInteractionInteractionWorkflowStageModelEnum;
  overrideReasonDetail?: string | null;
  notes?: FanguardApiContractsInteractionInteractionNoteModel[] | null;
  detectedImageUrl?: string | null;
  contextImageUrl?: string | null;
  personPhotoImageUrl?: string | null;
  /** @format double */
  confidence?: number | null;
  /** @format double */
  similarity?: number | null;
  /** @format double */
  spoofProbability?: number | null;
  spoofAlgorithmName?: string | null;
  spoofAlgorithmVersion?: string | null;
  faceTrackId?: string | null;
  /** @format int32 */
  eyeDistance?: number | null;
  createdBy?: string | null;
  source?: string | null;
  ageVerificationRequested?: boolean;
  orders?: FanguardApiContractsInteractionInteractionOrderResponseModel[] | null;
  tickets?: FanguardApiContractsInteractionInteractionTicketResponseModel[] | null;
  ticketScans?: FanguardApiContractsInteractionInteractionTicketScanResponseModel[] | null;
  hasContextImage?: boolean;
  displayedMessage?: string | null;
  providerResponse?: FanguardApiContractsInteractionInteractionProviderResponseModel;
  operation?: FanguardApiContractsInteractionInteractionDecisionOperationModel;
}

export interface FanguardApiContractsInteractionInteractionServiceRequestResponseModel {
  id: string;
  uri: string;
  requestDateTime: string;
  queryString: string;
  userAgent: string;
  method: string;
  requestBody: string;
  httpStatus: number;
  apiVersionRequested: string;
  responseBody: string;
  duration: number;
}

export interface FanguardApiContractsInteractionInteractionOutboundRequestResponseModel {
  id: string;
  fullUri: string;
  requestDateTime: string;
  method: string;
  requestBody: string;
  parameters: FanguardApiContractsInteractionInteractionOutboundRequestParameterResponseModel[];
  responseDateTime: string;
  isTimeout: boolean;
  duration: number;
  httpStatus: number;
  responseContent: string;
}

export interface FanguardApiContractsInteractionInteractionOutboundRequestParameterResponseModel {
  name: string;
  value: string;
  type: string;
}
export interface FanguardApiContractsInteractionInteractionDetails {
  serviceRequest: FanguardApiContractsInteractionInteractionServiceRequestResponseModel;
  outboundRequests: FanguardApiContractsInteractionInteractionOutboundRequestResponseModel[];
}
export interface FanguardApiContractsInteractionInteractionNotificationResponseModel {
  id?: string | null;
  client?: string | null;
  imageUrl?: string | null;
  indicator: 'Success' | 'Information' | 'Warning' | 'Failure';
  interactionType: 'AccessControl' | 'OrderFulfillment' | 'Ticketing';
  message?: string | null;
  notificationType?: number;
  timestamp: Date | string;
  title?: string | null;
  venueId?: string | null;
}

export interface FanguardApiContractsInteractionInteractionNotificationImageResponseModel {
  id?: string | null;
  imageUrl?: string | null;
  imageType?: string;
  indicator: 'Success' | 'Information' | 'Warning' | 'Failure';
  interactionId?: string | null;
  timestamp: Date | string;
}

export interface FanguardApiContractsInteractionInteractionSharedUrlResponseModel {
  url?: string | null;
}

export interface FanguardApiContractsInteractionInteractionTicketResponseModel {
  /** @format date-time */
  createdOn?: string | null;
  /** @format date-time */
  modifiedOn?: string | null;
  personReference?: string | null;
  eventReference?: string | null;
  priceReference?: string | null;
  ticketReference?: string | null;
  deliveryReference?: string | null;
  seat?: string | null;
  row?: string | null;
  section?: string | null;
  statusDetail?: FanguardApiContractsInteractionTicketStatusDetailModelEnumKeys;
  scans?: FanguardApiContractsInteractionInteractionTicketScanResponseModel[] | null;
}

export interface FanguardApiContractsInteractionInteractionTicketScanResponseModel {
  redemptionCorrelation?: string | null;
  /** @format date-time */
  createdOn?: string | null;
  accepted?: boolean;
  ticketReference?: string | null;
  scanType?: FanguardApiContractsInteractionTicketScanTypeModelEnum;
  resultDetail?: FanguardApiContractsInteractionTicketRedemptionResultDetailModelEnumKeys;
  resultDetailRaw?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsInteractionInteractionTypeEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
}

export enum FanguardApiContractsInteractionInteractionValidationStatusModelEnum {
  Unknown,
  Incorrect,
  Correct,
}

export type FanguardApiContractsInteractionInteractionValidationStatusModelEnumKeys =
  keyof typeof FanguardApiContractsInteractionInteractionValidationStatusModelEnum;

export interface FanguardApiContractsInteractionInteractionValidationStatusUpdateModel {
  type?: FanguardApiContractsInteractionInteractionTypeEnum;
  validationStatus?: FanguardApiContractsInteractionInteractionValidationStatusModelEnumKeys;
}

/** @format int32 */
export enum FanguardApiContractsInteractionInteractionWorkflowStageModelEnum {
  New = 0,
  InReview = 1,
  Dismissed = 2,
  Dispatched = 3,
  ResolvedNegative = 4,
  ResolvedPositive = 5,
}

export type FanguardApiContractsInteractionInteractionWorkflowStageModelEnumKeys =
  keyof typeof FanguardApiContractsInteractionInteractionWorkflowStageModelEnum;

export const FanguardApiContractsInteractionInteractionWorkflowStageModelEnumValues = Object.values(
  FanguardApiContractsInteractionInteractionWorkflowStageModelEnum,
);

export interface FanguardApiContractsInteractionInteractionWorkflowStageUpdateModel {
  workflowStage?: FanguardApiContractsInteractionInteractionWorkflowStageModelEnum;
}

/** @format int32 */
export enum FanguardApiContractsInteractionTicketScanTypeModelEnum {
  Value0 = 0,
  Value1 = 1,
}

export enum FanguardApiContractsInteractionTicketStatusDetailModelEnum {
  ValidEntry,
  ValidExit,
  InvalidBarcode,
  GenericDenied,
  AlreadyEntered,
  ExitWithoutEntry,
  InternalAlreadyEntered,
  InternalExitWithoutEntry,
  TooEarly,
  TooLate,
  SectionRestriction,
  Voided,
  TicketForwarded,
  NotFound,
  InvalidLocation,
  ExitDisabled,
  Expired,
}

export type FanguardApiContractsInteractionTicketRedemptionResultDetailModelEnumKeys =
  keyof typeof FanguardApiContractsInteractionTicketStatusDetailModelEnum;

export type FanguardApiContractsInteractionTicketStatusDetailModelEnumKeys =
  keyof typeof FanguardApiContractsInteractionTicketStatusDetailModelEnum;

export interface FanguardApiContractsJobJobDetailMessage {
  message?: string | null;
  level?: string | null;
  /** @format date-time */
  createdOn?: string;
}

export interface FanguardApiContractsJobJobDetailModel {
  /** @format int32 */
  totalItems?: number;
  /** @format int32 */
  successItems?: number;
  /** @format int32 */
  failedItems?: number;
  complete?: boolean;
  messages?: FanguardApiContractsJobJobDetailMessage[] | null;
}

export interface FanguardApiContractsOrderClaimOrderRequestModel {
  interactionId?: string | null;
  /** @format int32 */
  operatorId?: number;
  itemIds?: number[] | null;
}

export interface FanguardApiContractsOrderLineItemRequestModel {
  itemId?: string | null;
  externalId?: string | null;
  barcode?: string | null;
  description?: string | null;
  /** @format int32 */
  quantity?: number;
  /** @format float */
  unitPrice?: number;
  /** @format float */
  unitDiscount?: number | null;
  /** @format float */
  tax?: number | null;
  /** @format float */
  subtotalPrice?: number;
  /** @format float */
  totalPrice?: number;
}

export interface FanguardApiContractsOrderOperatorValidationResultModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface FanguardApiContractsOrderOrderCompleteRequestModel {
  interactionId?: string | null;
  orderNumber?: string | null;
  status?: string | null;
  /** @format float */
  totalTax?: number | null;
  /** @format float */
  totalFee?: number | null;
  /** @format float */
  totalDiscount?: number | null;
  /** @format float */
  subtotalPrice?: number;
  /** @format float */
  totalPrice?: number;
  lineItems?: FanguardApiContractsOrderLineItemRequestModel[] | null;
}

export interface FanguardApiContractsPagedItemsModel1FanguardApiContractsPersonPersonDetailModel {
  items?: FanguardApiContractsPersonPersonDetailModel[] | null;
  /** @format int64 */
  totalItems?: number;
}

export interface FanguardApiContractsPagedItemsModel1FanguardApiContractsPersonPersonSummaryModel {
  items?: FanguardApiContractsPersonPersonSummaryModel[] | null;
  /** @format int64 */
  totalItems?: number;
}

export interface FanguardApiContractsPermissionGroupModel {
  id?: string | null;
  name?: string | null;
  permissions?: string[] | null;
  statuses?: FanguardApiContractsAlertAlertStatus[] | null;
  watchlists?: string[] | null;
}

export interface FanguardApiContractsPermissionPermissionModel {
  id?: string | null;
  description?: string | null;
}

export interface FanguardApiContractsPersonAddPersonNoteRequestModel {
  personId?: string | null;
  note?: string | null;
  createdBy?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsPersonAddPhotoWorkflowEnum {
  Value0 = 0, // addPhoto ?
  Value1 = 1, // ?
}

export interface FanguardApiContractsPersonAiFiCart {
  id?: string | null;
  name?: string | null;
  /** @format double */
  price?: number | null;
  totalTax?: string | null;
  subtotalPrice?: string | null;
  totalPrice?: string | null;
  barcode?: string | null;
  thumbnail?: string | null;
  externalId?: string | null;
  /** @format int32 */
  quantity?: number | null;
}

export interface FanguardApiContractsPersonAiFiCheckoutRequest {
  /** @format int32 */
  orderId?: number | null;
  sessionId?: string | null;
  status?: string | null;
  cart?: FanguardApiContractsPersonAiFiCart[] | null;
  totalPrice?: string | null;
  totalTax?: string | null;
  subtotalPrice?: string | null;
}

export interface FanguardApiContractsPersonCreateGuestRequest {
  interactionId?: string | null;
  photo?: string | null;
  token?: string | null;
}

export interface FanguardApiContractsPersonEmailVerificationRequest {
  siteId?: string | null;
  ageConfirmed?: boolean;
  redirectUri?: string | null;
}

export interface FanguardApiContractsPersonEnrolledCampaignModel {
  siteId?: string | null;
  campaignId?: string | null;
  status?: FanguardApiContractsPersonEnrollmentStatusEnumKeys;
  /** @format date-time */
  requestedOn?: string | null;
  /** @format date-time */
  startedOn?: string | null;
  /** @format date-time */
  completedOn?: string | null;
}

export interface FanguardApiContractsPersonEnrolledCampaignSummaryModel {
  siteId?: string | null;
  campaignId?: string | null;
  status?: FanguardApiContractsPersonEnrollmentStatusEnumKeys;
  /** @format date-time */
  requestedOn?: string | null;
  /** @format date-time */
  startedOn?: string | null;
  /** @format date-time */
  completedOn?: string | null;
  siteName?: string | null;
  campaignName?: string | null;
}

export interface FanguardApiContractsPersonEnrollmentEmailRequestModel {
  siteId?: string | null;
  campaignId?: string | null;
  sendEmailConfirmation?: boolean;
  personIds?: string[] | null;
}

export interface FanguardApiContractsPersonEnrollmentRequestModel {
  siteId?: string | null;
  campaignId?: string | null;
  connectionType?: FanguardApiContractsClientConnectionTypeModelEnumKeys;
  personId?: string | null;
  lastStep?: boolean;
}

/** @format int32 */
export enum FanguardApiContractsPersonEnrollmentStatusEnum {
  Requested = 0,
  Started,
  Completed,
}

export type FanguardApiContractsPersonEnrollmentStatusEnumKeys =
  keyof typeof FanguardApiContractsPersonEnrollmentStatusEnum;

export interface FanguardApiContractsPersonImpersonateResponseModel {
  token?: string | null;
}

export interface FanguardApiContractsPersonLinkedAccount {
  accountId?: string | null;
  email?: string | null;
  name?: string | null;
  source?: FanguardApiContractsPersonLinkedAccountSource;
  provenueAccessCardBarcode?: string | null;
  ticketmasterCustNameId?: string | null;
  axsMobileId?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsPersonLinkedAccountSource {
  Value0 = 0,
  Value1 = 1,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
  Value11 = 11,
  Value12 = 12,
  Value14 = 14,
}

export interface FanguardApiContractsPersonPaymentCardModel {
  id?: string | null;
  maskedCardNumber?: string | null;
  cardType?: string | null;
  /** @format date-time */
  createdOn?: string;
  isDefault?: boolean;
}

export interface FanguardApiContractsPersonPaymentCardRemovalRequestModel {
  personId?: string | null;
}

export interface FanguardApiContractsPersonPaymentCardRequestModel {
  personId?: string | null;
  token?: string | null;
}

export interface FanguardApiContractsPersonPersonBulkAddToWatchlistRequestModel {
  personIds?: string[] | null;
  watchlistId?: string | null;
}

export interface FanguardApiContractsPersonPersonBulkPhotoRequestModel {
  personIds?: string[] | null;
  watchlistId?: string | null;
  searchTerm?: string | null;
}

export interface FanguardApiContractsPersonPersonBulkRemoveFromWatchlistRequestModel {
  personIds?: string[] | null;
  watchlistId?: string | null;
  searchTerm?: string | null;
}

export interface FanguardApiContractsPersonPersonClassifierCredentialModel {
  /** @format int64 */
  facilityCode?: number;
  /** @format int64 */
  cardNumber?: number;
}

export interface FanguardApiContractsPersonPersonClassifierModificationModel {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format int32 */
  batchNumber?: number | null;
  /** @format int32 */
  cardNumber?: number | null;
  propertyCredentials?: FanguardApiContractsPersonPersonClassifierCredentialModel[] | null;
  watchlistId?: string | null;
  photos?: FanguardApiContractsPersonPersonPhotoClassifierModificationModel[] | null;
  /** @format date-time */
  lastEmbeddingModifiedOn?: string;
  personCredentials?: FanguardApiContractsPersonPersonClassifierCredentialModel[] | null;
  ofAge?: boolean;
}

export interface FanguardApiContractsPersonPersonClassifierRemovalModel {
  watchlistId?: string | null;
  personPhotoId?: string | null;
  /** @format date-time */
  removedOn?: string;
}

export interface FanguardApiContractsPersonPersonClassifierSetModel1FanguardApiContractsPersonPersonClassifierModificationModel {
  items?: FanguardApiContractsPersonPersonClassifierModificationModel[] | null;
  /** @format int32 */
  pageSize?: number;
}

export interface FanguardApiContractsPersonPersonClassifierSetModel1FanguardApiContractsPersonPersonClassifierRemovalModel {
  items?: FanguardApiContractsPersonPersonClassifierRemovalModel[] | null;
  /** @format int32 */
  pageSize?: number;
}

export interface FanguardApiContractsPersonPersonCreateLinkedAccountRequestModel {
  accountId?: string | null;
  email?: string | null;
  source?: FanguardApiContractsPersonLinkedAccountSource;
  provenueAccessCardBarcode?: string | null;
}

export interface FanguardApiContractsPersonPersonCreateRequestModel {
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /** @format email */
  email?: string | null;
  location?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  company?: string | null;
  department?: string | null;
  comments?: string | null;
  watchlists?: string[] | null;
  photo?: string | null;
  client?: string | null;
  force?: boolean;
  credentials?: FanguardApiContractsPersonPersonCredentialModel[] | null;
  sendDecisionNotification?: boolean | null;
  externalData?: Record<string, string | null>;
  source?: string | null;
  optIn?: boolean | null;
  ageConfirmed?: boolean | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  phoneNumber?: string | null;
  linkedAccounts?: FanguardApiContractsPersonPersonCreateLinkedAccountRequestModel[] | null;
}

export interface FanguardApiContractsPersonPersonPhotoResponseModel {
  person: FanguardApiContractsPersonPersonDetailModel;
  photoStatus: number;
}

export interface FanguardApiContractsPersonPersonCredentialModel {
  /** @format int64 */
  facilityCode?: number;
  /** @format int64 */
  cardNumber?: number;
  readOnly?: boolean;
}

export interface FanguardApiContractsPersonPersonDetailModel {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  location?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  gender?: string | null;
  comments?: string | null;
  watchlists?: string[] | null;
  photoUrls?: string[] | null;
  notes?: FanguardApiContractsPersonPersonNoteModel[] | null;
  photos?: FanguardApiContractsPersonPersonPhotoModel[] | null;
  recentAlerts?: FanguardApiContractsInteractionInteractionResponseModel[] | null;
  credentials?: FanguardApiContractsPersonPersonCredentialModel[] | null;
  readOnly?: boolean;
  sendDecisionNotification?: boolean;
  externalData?: Record<string, string | null>;
  linkedAccounts?: FanguardApiContractsPersonLinkedAccount[] | null;
  accountId?: string | null;
  tmAccountId?: string | null;
  provenuePatronId?: string | null;
  provenueAccessCardBarcode?: string | null;
  /** @format date-time */
  createdOn?: string | null;
  /** @format date-time */
  lastSeenOn?: string | null;
  /** @format date-time */
  optInTimestamp?: string | null;
  /** @format date-time */
  ageConfirmationTimestamp?: string | null;
  /** @format date-time */
  idVerificationTimestamp?: string | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  is21?: boolean | null;
  phoneNumber?: string | null;
  enrolledCampaigns?: FanguardApiContractsPersonEnrolledCampaignModel[] | null;
  paymentCards?: FanguardApiContractsPersonPaymentCardModel[] | null;
}

export interface FanguardApiContractsPersonPersonNoteModel {
  id?: string | null;
  note?: string | null;
  /** @format date-time */
  createdOn?: string;
  createdBy?: string | null;
  venueId?: string | null;
  eventId?: string | null;
}

export interface FanguardApiContractsPersonPersonPhotoClassifierModificationModel {
  id?: string | null;
  embedding?: number[] | null;
  /** @format int32 */
  maskStatus?: number;
  /** @format int32 */
  hatStatus?: number;
  /** @format int32 */
  sunglassesStatus?: number;
}

export interface FanguardApiContractsPersonPersonPhotoModel {
  id?: string | null;
  largeFileId?: string | null;
  thumbnailFileId?: string | null;
  status?: FanguardApiContractsPersonPersonPhotoStatusEnum;
  url?: string | null;
  hasHat?: boolean | null;
  hasMask?: boolean | null;
  hasSunglasses?: boolean | null;
  hasOpenMouth?: boolean | null;
  hasAccessory?: boolean | null;
  existingPersonId?: string | null;
}

export interface FanguardApiContractsPersonPersonPhotoRequestModel {
  /** @minLength 1 */
  photo: string;
  force?: boolean;
  deleteInvitation?: boolean;
  workflow?: '?' | 'addPhoto';
}

export interface FanguardApiContractsPersonPersonPhotoErrorResponsModel {
  defaultMessage: string;
  hasAccessory: boolean;
  hasHat: boolean;
  hasMask: boolean;
  hasOpenMouth: boolean;
  hasSunglasses: boolean;
  status: string;
}

export interface FanguardApiContractsPersonPersonPhotoSuccessResponsModel {
  defaultMessage: string;
  hasAccessory: boolean;
  hasHat: boolean;
  hasMask: boolean;
  hasOpenMouth: boolean;
  url: string;
  status: string;
  id: string;
}

export interface FanguardApiContractsPersonPersonPhotoRequestRequestModel {
  multiple?: boolean;
}

/** @format int32 */
export enum FanguardApiContractsPersonPersonPhotoStatusEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
  Value11 = 11,
  Value12 = 12,
  Value13 = 13,
  Value14 = 14,
  Value15 = 15,
  Value16 = 16,
  Value17 = 17,
  Value18 = 18,
  Value19 = 19,
  Value20 = 20,
  Value21 = 21,
  Value22 = 22,
  Value23 = 23,
  Value24 = 24,
  Value25 = 25,
}

export interface FanguardApiContractsPersonPersonSearchRequest {
  photo?: string | null;
}

export interface FanguardApiContractsPersonPersonSearchResponse {
  /** @format date-time */
  timestamp?: string | null;
  personId?: string | null;
  personName?: string | null;
  source?: string | null;
  /** @format double */
  similarity?: number | null;
  /** @format double */
  confidence?: number | null;
  /** @format double */
  businessConfidence?: number | null;
  /** @format double */
  score?: number;
  photo?: string | null;
  photoUrl?: string | null;
  watchlists?: Record<string, string | null>;
  /** @format int32 */
  rotationCorrection?: number;
  status?: FanguardApiContractsPersonPersonSearchResponseStatus;
  over21?: boolean | null;
}

/** @format int32 */
export enum FanguardApiContractsPersonPersonSearchResponseStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

export interface FanguardApiContractsPersonPersonSummaryModel {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  gender?: string | null;
  comments?: string | null;
  watchlists?: string[] | null;
  primaryPhoto?: FanguardApiContractsPersonPersonPhotoModel;
  /** @format int32 */
  photoCount?: number;
  photos?: FanguardApiContractsPersonPersonPhotoModel[] | null;
  readOnly?: boolean;
  sendDecisionNotification?: boolean;
  /** @format date-time */
  createdOn?: string | null;
  /** @format date-time */
  lastSeenOn?: string | null;
  dateOfBirth?: string | null;
  is21?: boolean | null;
}

export interface FanguardApiContractsPersonPersonUpdateRequestModel {
  firstName?: string | null;
  lastName?: string | null;
  /** @format email */
  email?: string | null;
  isEmailSet?: boolean;
  location?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  company?: string | null;
  department?: string | null;
  comments?: string | null;
  watchlists?: string[] | null;
  photo?: string | null;
  client?: string | null;
  force?: boolean;
  sendDecisionNotification?: boolean | null;
  credentials?: FanguardApiContractsPersonPersonCredentialModel[] | null;
  containsAllowableChange?: boolean;
  optIn?: boolean | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  formId?: string | null;
  externalRequestId?: string | null;
  phoneNumber?: string | null;
  ageConfirmed?: boolean | null;
  externallyActive?: boolean;
}

export interface FanguardApiContractsSensorAccessControlZoneModel {
  /** @format float */
  x1?: number;
  /** @format float */
  y1?: number;
  /** @format float */
  x2?: number;
  /** @format float */
  y2?: number;
  isValid?: boolean;
}

export interface FanguardApiContractsSensorCameraSettingsModel {
  cameraUrl?: string | null;
  enableTapToStart?: boolean;
  enableZmqInterface?: boolean;
}

/** @format int32 */
export enum FanguardApiContractsSensorDeviceStatusEnum {
  offline,
  online,
  unknown,
}

export type FanguardApiContractsSensorDeviceStatusEnumKeys = keyof typeof FanguardApiContractsSensorDeviceStatusEnum;

export interface FanguardApiContractsSensorGraphPoint {
  x?: string | null;
  /** @format double */
  y?: number | null;
}

export interface FanguardApiContractsSensorGraphSeries {
  name?: string | null;
  key?: string | null;
  data?: FanguardApiContractsSensorGraphPoint[] | null;
}

export interface FanguardApiContractsSensorImageSettingsModel {
  enabled?: boolean;
  /** @format int32 */
  height?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  quality?: number;
}

export interface FanguardApiContractsSensorKioskColorPaletteModel {
  /** @format double */
  backgroundImageOpacity?: number | null;
  primaryColor?: string | null;
  secondaryColor?: string | null;
  numberColor?: string | null;
  standard?: FanguardApiContractsSensorKioskScreenColorsModel;
  knownPersonAccepted?: FanguardApiContractsSensorKioskScreenColorsModel;
  knownPersonDenied?: FanguardApiContractsSensorKioskScreenColorsModel;
  unknownPerson?: FanguardApiContractsSensorKioskScreenColorsModel;
}

export interface FanguardApiContractsSensorKioskColorPaletteRequestModel {
  /** @format int32 */
  backgroundImageOpacity?: number | null;
  primaryColor?: string | null;
  secondaryColor?: string | null;
  numberColor?: string | null;
  standard?: FanguardApiContractsSensorKioskScreenColorsRequestModel;
  knownPersonAccepted?: FanguardApiContractsSensorKioskScreenColorsRequestModel;
  knownPersonDenied?: FanguardApiContractsSensorKioskScreenColorsRequestModel;
  unknownPerson?: FanguardApiContractsSensorKioskScreenColorsRequestModel;
}

export interface FanguardApiContractsSensorKioskConfigurationModel {
  viewfinderEnabled?: boolean;
  enableTapToStart?: boolean;
  enableZmqInterface?: boolean;
  scanningMethod?: string;
  design?: Record<string, FanguardApiContractsSensorKioskDesignModel>;
  messages?: FanguardApiContractsSensorKioskMessagesModel;
}

export interface FanguardApiContractsSensorKioskConfigurationRequestModel {
  exitPassword?: string | null;
  viewfinderEnabled?: boolean | null;
  enableTapToStart?: boolean | null;
  enableZmqInterface?: boolean | null;
  scanningMethod?: string;
  design?: Record<string, FanguardApiContractsSensorKioskDesignRequestModel>;
  messages?: FanguardApiContractsSensorKioskMessagesRequestModel;
}

export interface FanguardApiContractsSensorKioskDayPassMessagesModel {
  unenrolledTitle?: string | null;
  unenrolledMessage?: string | null;
  unenrolledConfirmationText?: string | null;
  unenrolledCancelText?: string | null;
  alreadyEnrolledTitle?: string | null;
  alreadyEnrolledMessage?: string | null;
  alreadyEnrolledConfirmationText?: string | null;
  enrollmentSuccessTitle?: string | null;
  enrollmentSuccessMessage?: string | null;
  enrollmentSuccessConfirmationText?: string | null;
  guestDataDisclaimerText?: string | null;
}

export interface FanguardApiContractsSensorKioskDayPassMessagesRequestModel {
  unenrolledTitle?: string | null;
  unenrolledMessage?: string | null;
  unenrolledConfirmationText?: string | null;
  unenrolledCancelText?: string | null;
  alreadyEnrolledTitle?: string | null;
  alreadyEnrolledMessage?: string | null;
  alreadyEnrolledConfirmationText?: string | null;
  enrollmentSuccessTitle?: string | null;
  enrollmentSuccessMessage?: string | null;
  enrollmentSuccessConfirmationText?: string | null;
  guestDataDisclaimerText?: string | null;
}

export interface FanguardApiContractsSensorKioskDesignModel {
  images?: Record<string, FanguardApiContractsSensorKioskImageModel>;
  colors?: FanguardApiContractsSensorKioskColorPaletteModel;
}

export interface FanguardApiContractsSensorKioskDesignRequestModel {
  images?: Record<string, FanguardApiContractsSensorKioskImageRequestModel>;
  colors?: FanguardApiContractsSensorKioskColorPaletteRequestModel;
}

export interface FanguardApiContractsSensorKioskGeneralMessagesModel {
  personNameDisplayTemplate?: string | null;
  entryConfirmation?: string | null;
  entryDenied?: string | null;
  exitConfirmation?: string | null;
  exitDenied?: string | null;
}

export interface FanguardApiContractsSensorKioskGeneralMessagesRequestModel {
  personNameDisplayTemplate?: string | null;
  entryConfirmation?: string | null;
  entryDenied?: string | null;
  exitConfirmation?: string | null;
  exitDenied?: string | null;
}

export interface FanguardApiContractsSensorKioskImageModel {
  id?: string | null;
  image?: string | null;
  name?: string | null;
  /** @format int64 */
  size?: number | null;
  /** @format int32 */
  displaySizePercentage?: number | null;
  url?: string | null;
  delete?: boolean;
}

export interface FanguardApiContractsSensorKioskImageRequestModel {
  id?: string | null;
  image?: string | null;
  name?: string | null;
  /** @format int64 */
  size?: number | null;
  /** @format int32 */
  displaySizePercentage?: number | null;
  url?: string | null;
  delete?: boolean;
}

export interface FanguardApiContractsSensorKioskIntroductionMessagesModel {
  message?: string | null;
  title?: string | null;
  startOnAttentionButtonText?: string | null;
  startOffAttentionButtonText?: string | null;
}

export interface FanguardApiContractsSensorKioskIntroductionMessagesRequestModel {
  message?: string | null;
  title?: string | null;
  startOnAttentionButtonText?: string | null;
  startOffAttentionButtonText?: string | null;
}

export interface FanguardApiContractsSensorKioskMessagesModel {
  general?: FanguardApiContractsSensorKioskGeneralMessagesModel;
  introduction?: FanguardApiContractsSensorKioskIntroductionMessagesModel;
  dayPass?: FanguardApiContractsSensorKioskDayPassMessagesModel;
}

export interface FanguardApiContractsSensorKioskMessagesRequestModel {
  general?: FanguardApiContractsSensorKioskGeneralMessagesRequestModel;
  introduction?: FanguardApiContractsSensorKioskIntroductionMessagesRequestModel;
  dayPass?: FanguardApiContractsSensorKioskDayPassMessagesRequestModel;
}

export interface FanguardApiContractsSensorKioskScreenColorsModel {
  backgroundColor?: string | null;
  backgroundColorOverlay?: string | null;
  /** @format double */
  backgroundColorOpacity?: number | null;
  textColor?: string | null;
  showBackgroundImage?: boolean | null;
}

export interface FanguardApiContractsSensorKioskScreenColorsRequestModel {
  backgroundColor?: string | null;
  backgroundColorOverlay?: string | null;
  /** @format double */
  backgroundColorOpacity?: number | null;
  textColor?: string | null;
  showBackgroundImage?: boolean | null;
}

/** @format int32 */
export enum FanguardApiContractsSensorPersonNameDisplayTemplateEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export interface FanguardApiContractsSensorRecognitionSettingsModel {
  snapshot?: FanguardApiContractsSensorSnapshotImageSettingsModel;
  contextImage?: FanguardApiContractsSensorImageSettingsModel;
  enabled?: boolean;
  diagnosticsEnabled?: boolean;
  spoofDetectionEnabled?: boolean;
  intentDetectionEnabled?: boolean;
  /** @format double */
  spoofThreshold?: number | null;
  securityMode?: FanguardApiContractsSensorSensorSecurityModeModel;
  accessControlMode?: FanguardApiContractsSensorSensorAccessControlModeModelKeys;
  accessControlZone?: FanguardApiContractsSensorAccessControlZoneModel;
  zones?: Record<string, number[][] | null>;
  /** @format int32 */
  detectionDistance?: number | null;
  blurFaces?: boolean;
  requireConfirmationAfterGranted?: boolean;
  campaignIds?: string[] | null;
  enrollmentQuickCheckEnabled?: boolean;
  dayPassTicketingCampaignId?: string;
  allowDayPassScans?: boolean;
  allowTicketlessEnrollment?: boolean;
  audioFeedbackEnabled?: boolean;
  screenSaverEnabled?: boolean;
  /** @format double */
  accessResultTimeout?: number | null;
  credentialingPreCheckEnabled?: boolean;
  credentialingPrinterId?: string | null;
  credentialingPrinterGroupId?: string | null;
  dayPassTicketingCampaignSiteId?: string;
  registrationDayPassId?: string;
  redemptionDayPassIds?: string[];
  autoAssignDayPassIds?: string[];
}

/** @format int32 */
export enum FanguardApiContractsSensorSensorAccessControlModeModel {
  Normal,
  Ticketing,
  Credentialing,
  CredentialingCheckIn,
  OrderFulfillment,
  AgeVerification,
  EnrollmentCheck,
  DayPass,
  RemoteTicketing,
  Multimode,
  DayPassEnrollment,
  LocalSalto,
  WebView,
}

export type FanguardApiContractsSensorSensorAccessControlModeModelKeys =
  keyof typeof FanguardApiContractsSensorSensorAccessControlModeModel;

export interface FanguardApiContractsSensorSensorBeatModel {
  batteryLevel?: number | null;
  batteryState?: FanguardApiContractsBoxBatteryStateModelEnum;
  status?: FanguardApiContractsBoxDeviceDetailStatusEnum;
  softwareVersion?: string | null;
  hostVersion?: string | null;
  metrics?: Record<string, number | null>;
  /** @format date-time */
  timestamp?: string;
  /** @format date-time */
  boxTimestamp?: string;
  ipAddress?: string | null;
  /** @format int32 */
  pairingStatus?: FanguardApiContractsBoxPairingStatusKeys;
  displayMode?: FanguardApiContractsBoxDisplayModeKeys;
}

export interface FanguardApiContractsSensorSessionSettingsModel {
  sessionId?: string;
  sessionTimeId?: string;
  code?: string;
  title?: string;
  startTime?: string;
  endTime?: string;
  startTimeMillis?: number;
  endTimeMillis?: number;
  enabled?: boolean;
}
export interface FanguardApiContractsSensorSensorConfigurationModel {
  version?: string | null;
  recognition?: FanguardApiContractsSensorRecognitionSettingsModel;
  sensor?: FanguardApiContractsSensorCameraSettingsModel;
  system?: FanguardApiContractsSensorSystemSettingsModel;
  session?: FanguardApiContractsSensorSessionSettingsModel;
}

export interface FanguardApiContractsSensorSensorCreateRequestModel {
  name?: string | null;
  client?: string | null;
  type?: FanguardApiContractsSensorSensorModelTypeEnum;
  platform?: FanguardApiContractsSensorSensorModelPlatformEnum;
  /** @format int32 */
  assetId?: number | null;
  venueId?: string | null;
  minionName?: string | null;
}

export interface FanguardApiContractsSensorSensorCrowdModel {
  /** @format int32 */
  count?: number;
  /** @format int32 */
  level?: number | null;
  /** @format int32 */
  thresholdBreached?: number | null;
  /** @format date-time */
  timestamp?: string;
}

export interface FanguardApiContractsSensorSensorGraphModel {
  series?: FanguardApiContractsSensorGraphSeries[] | null;
}

export interface FanguardApiContractsSensorSensorGroupConfigurationModel {
  kiosk?: FanguardApiContractsSensorKioskConfigurationModel;
  ticketingConnectionId?: string | null;
}

export interface FanguardApiContractsSensorSensorGroupConfigurationRequestModel {
  kiosk?: FanguardApiContractsSensorKioskConfigurationRequestModel;
}

export interface FanguardApiContractsSensorSensorGroupDetailModel {
  id?: string | null;
  client?: string | null;
  name?: string | null;
  useMaskedPeoplePhotos?: boolean;
  sensors?: Record<string, string | null>;
  configuration?: FanguardApiContractsSensorSensorGroupConfigurationModel;
}

export interface FanguardApiContractsSensorSensorGroupModel {
  id?: string | null;
  client?: string | null;
  name?: string | null;
  useMaskedPeoplePhotos?: boolean;
  sensors?: Record<string, string | null>;
  configuration?: FanguardApiContractsSensorSensorGroupConfigurationModel;
}

export interface FanguardApiContractsSensorSensorGroupRequestModel {
  name?: string | null;
  sensors?: string[] | null;
  useMaskedPeoplePhotos?: boolean | null;
  configuration?: FanguardApiContractsSensorSensorGroupConfigurationRequestModel;
}

export interface FanguardApiContractsSensorSensorModel {
  id?: string | null;
  name?: string | null;
  status?: FanguardApiContractsSensorDeviceStatusEnumKeys;
  snapshotUrl?: string | null;
  /** @format date-time */
  snapshotUpdatedOn?: string | null;
  watchlists?: FanguardApiContractsSensorSensorWatchlistModel[] | null;
  latestBeat?: FanguardApiContractsSensorSensorBeatModel;
  configuration?: FanguardApiContractsSensorSensorConfigurationModel;
  type?: FanguardApiContractsSensorSensorModelTypeEnum;
  platform?: FanguardApiContractsSensorSensorModelPlatformEnum;
  venueId?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  placementName?: string | null;
  minionName?: string | null;
  sensorGroupId?: string | null;
  isOnline?: boolean;
  externalData?: Record<string, string>;
  tmDeviceId?: string | null;
  latestCrowd?: FanguardApiContractsSensorSensorCrowdModel;
  client?: string | null;
  areSnapshotsEnabled?: boolean;
  sensorPair?: FanguardApiContractsSensorSensorPairModel;
  connectionId?: string | null;
  workflowUri?: string | null;
  /** @format double */
  preAuthAmount?: number | null;
  thumbprint?: string | null;
  capabilities?: FanguardApiContractsSensorSensorCapabilitiesModel;
  reportCategory?: string | null;
  audioFeedbackEnabled?: boolean;
  deviceModel?: string | null;
  hostApp?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsSensorSensorModelPlatformEnum {
  Unknown = 'unknown', // unknown
  Ios = 'ios', // ios
  Android = 'android', // android
}

/** @format int32 */
export enum FanguardApiContractsSensorSensorModelTypeEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

export enum FanguardApiContractsSensorSensorModelCapabilitiesModelEnum {
  liveness3D = 'liveness3D',
  liveness3Dv2 = 'liveness3Dv2',
  liveness2D = 'liveness2D',
}

export interface FanguardApiContractsSensorSensorCapabilitiesModel {
  liveness3D?: boolean | null;
  liveness3Dv2?: boolean | null;
  liveness2D?: boolean | null;
  audioFeedback?: boolean | null;
}

export interface FanguardApiContractsSensorSensorPairModel {
  sensorIds?: string[] | null;
  guestSensorId?: string | null;
  attendantSensorId?: string | null;
  operatorSensorId?: string | null;
  sensorPairingMode?: FanguardApiContractsSensorSensorPairingModeKeys;
}

export interface FanguardApiContractsSensorSensorPairRequestModel {
  sensorIds?: string[] | null;
  guestSensorId?: string | null;
  attendantSensorId?: string | null;
  operatorSensorId?: string | null;
  sensorPairingMode?: FanguardApiContractsSensorSensorPairingModeKeys;
}

/** @format int32 */
export enum FanguardApiContractsSensorSensorPairingMode {
  Auto,
  Wifi,
  Bluetooth,
}

export type FanguardApiContractsSensorSensorPairingModeKeys = keyof typeof FanguardApiContractsSensorSensorPairingMode;

export type FanguardApiContractsSensorSensorRequestDiagnosticUploadModel = object;

/** @format int32 */
export enum FanguardApiContractsSensorSensorSecurityModeModel {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

export interface FanguardApiContractsSensorSensorUpdateRequestModel {
  name?: string | null;
  watchlistIds?: string[] | null;
  configuration?: FanguardApiContractsSensorSensorConfigurationModel;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  placementName?: string | null;
  venueId?: string | null;
  minionName?: string | null;
  externalData?: Record<string, string>;
  noPrinterSelected?: boolean;
  sensorPair?: FanguardApiContractsSensorSensorPairRequestModel;
  connectionId?: string | null;
  /** @format double */
  preAuthAmount?: number | null;
}

export interface FanguardApiContractsSensorSensorWatchlistModel {
  watchlistId?: string | null;
  watchlistName?: string | null;
  status?: FanguardApiContractsSensorSensorWatchlistStatusEnumKeys;
}

/** @format int32 */
export enum FanguardApiContractsSensorSensorWatchlistStatusEnum {
  current,
  outdated,
  missing,
}

export type FanguardApiContractsSensorSensorWatchlistStatusEnumKeys =
  keyof typeof FanguardApiContractsSensorSensorWatchlistStatusEnum;

export interface FanguardApiContractsSensorSnapshotImageSettingsModel {
  enabled?: boolean;
  /** @format int32 */
  height?: number;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  quality?: number;
  /** @format int32 */
  interval?: number;
}

export interface FanguardApiContractsSensorSystemSettingsModel {
  /** @format int32 */
  beatInterval?: number;
  /** @format int32 */
  assetId?: number | null;
  /** @format int32 */
  readerNumber?: number | null;
  /** @format int32 */
  entryNumber?: number | null;
  /** @format int32 */
  laneNumber?: number | null;
  panelInterfaceEndpoint?: string | null;
  crowdCountThresholds?: number[] | null;
  scanFacilityCode?: string | null;
  scanAreaCode?: string | null;
  scanDeviceCode?: string | null;
  credentialAreaCode?: string | null;
  controllerId?: string | null;
  controllerName?: string | null;
  /** @format int32 */
  controllerPort?: number | null;
  allowedPriceScales?: string[] | null;
  orderFulfillmentLocationCode?: string | null;
  orderFulfillmentDeviceCode?: string | null;
  uri?: string | null;
  panelAuthKey?: string | null;
  doorId?: string | null;
}

export interface FanguardApiContractsTicketCreateTicketRequestModel {
  eventId?: string | null;
  personId?: string | null;
  section?: string | null;
  row?: string | null;
  seat?: string | null;
  type?: string | null;
  statusDetail?: FanguardApiContractsTicketTicketStatusDetailEnum;
}

export interface FanguardApiContractsTicketRemoteTicketingRequestModel {
  transactionId?: string | null;
  tickets?: FanguardApiContractsTicketRemoteTicketingTicketRequestModel[] | null;
}

export interface FanguardApiContractsTicketRemoteTicketingTicketRequestModel {
  seat?: string | null;
  row?: string | null;
  section?: string | null;
  redemptionAttempted?: boolean;
  scanStatus?: string | null;
  scanStatusDetail?: string | null;
  priceReference?: string | null;
}

export interface FanguardApiContractsTicketSectionModel {
  id?: string | null;
  /**
   * @minLength 1
   * @pattern ^[a-zA-Z0-9]*$
   */
  name: string;
  rows?: string[] | null;
}

export interface FanguardApiContractsTicketTicketGroupCreateRequestModel {
  /** @minLength 1 */
  name: string;
  /** @pattern ^([0-9a-fA-F]{3}){1,2}$ */
  color?: string | null;
  sections?: FanguardApiContractsTicketSectionModel[] | null;
  priceCodes?: string[] | null;
}

export interface FanguardApiContractsTicketTicketGroupDetailModel {
  id?: string | null;
  name?: string | null;
  color?: string | null;
  sections?: FanguardApiContractsTicketSectionModel[] | null;
  priceCodes?: string[] | null;
}

export interface FanguardApiContractsTicketTicketGroupSummaryModel {
  id?: string | null;
  name?: string | null;
  color?: string | null;
  sectionNames?: string[] | null;
  priceCodes?: string[] | null;
}

export interface FanguardApiContractsTicketTicketGroupUpdateRequestModel {
  name?: string | null;
  /** @pattern ^([0-9a-fA-F]{3}){1,2}$ */
  color?: string | null;
  sections?: FanguardApiContractsTicketSectionModel[] | null;
  priceCodes?: string[] | null;
}

export interface FanguardApiContractsTicketTicketModel {
  id?: string | null;
  client?: string | null;
  source?: string | null;
  code?: string | null;
  /** @format date-time */
  createdOn?: string | null;
  createdBy?: string | null;
  /** @format date-time */
  modifiedOn?: string | null;
  personReference?: string | null;
  eventReference?: string | null;
  priceReference?: string | null;
  ticketReference?: string | null;
  deliveryReference?: string | null;
  seat?: string | null;
  row?: string | null;
  section?: string | null;
  statusDetail?: FanguardApiContractsTicketTicketStatusDetailEnum;
  isValid?: boolean;
  rawStatus?: string | null;
  groupName?: string | null;
  groupColor?: string | null;
}

export interface FanguardApiContractsTicketTicketScanRequest {
  decisionId?: string | null;
  tokens?: string[] | null;
  type?: FanguardApiContractsTicketTicketScanRequestTypeEnum;
}

/** @format int32 */
export enum FanguardApiContractsTicketTicketScanRequestTypeEnum {
  Value0 = 0,
  Value1 = 1,
}

export interface FanguardApiContractsTicketTicketScanResult {
  barcode?: string | null;
  token?: string | null;
  accepted?: boolean;
  error?: string | null;
}

export interface FanguardApiContractsTicketTicketScanSummary {
  accepted?: boolean;
  scanType?: FanguardApiContractsTicketTicketScanRequestTypeEnum;
  resultDetail?: string | null;
  barcode?: string | null;
  seat?: string | null;
  row?: string | null;
  section?: string | null;
  price?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsTicketTicketStatusDetailEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

export interface FanguardApiContractsUserAuthenticationRequest {
  username?: string | null;
  password?: string | null;
  refreshToken?: string | null;
  invitationCode?: string | null;
  authorizationCode?: string | null;
  tokenId?: string | null;
  auth0Token?: string | null;
  pathSegment?: string | null;
  axsAccessToken?: string | null;
  cventConfirmationNumber?: string | null;
  cventContactId?: string | null;
  type?: FanguardApiContractsUserAuthenticationRequestType;
  isValid?: boolean;
  client?: string | null;
  redirectUri?: string | null;
  ageConfirmed?: boolean | null;
  phone?: string | null;
  photo?: string | null;
  personToken?: string | null;
  attemptId?: string | null;
  otp?: string | null;
  verificationCode?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsUserAuthenticationRequestType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
  Value11 = 11,
}

export interface FanguardApiContractsUserDeviceModel {
  /** @minLength 1 */
  token: string;
  /** @minLength 1 */
  platform: string;
  client?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsUserInvitationTypeEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value4 = 4,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
}

export interface FanguardApiContractsUserLogoutRequest {
  deviceToken?: string | null;
}

export interface FanguardApiContractsUserSensorNotificationPreferencesResponseModel {
  sensorStatusChange?: boolean;
  densityThresholdExceeded?: boolean;
  ticketRedemptionSuccessful?: boolean;
  ticketRedemptionPartialFailure?: boolean;
  venueSensorStatusChange?: string[] | null;
}

export interface FanguardApiContractsUserSignAgreementRequest {
  agreementId?: string | null;
}

export interface FanguardApiContractsUserUserAlertNotificationPreferenceRequestModel {
  watchlistId?: string | null;
  alertStatuses?: string[] | null;
}

export interface FanguardApiContractsUserUserClientModel {
  id?: string | null;
  name?: string | null;
  domainSlug?: string | null;
}

export interface FanguardApiContractsUserUserClientPreferenceRequestModel {
  defaultVenueId?: string | null;
}

export interface FanguardApiContractsUserUserClientPreferenceResponseModel {
  defaultVenueId?: string | null;
}

export interface FanguardApiContractsUserUserDetailModel {
  username?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  preferences?: FanguardApiContractsUserUserPreferencesResponseModel;
  sysAdmin?: boolean;
  lockedOut?: boolean;
  clients?: FanguardApiContractsUserUserClientModel[] | null;
  source?: FanguardApiContractsUserUserSourceEnum;
  scopes?: FanguardApiContractsUserUserRequestScopeModel[] | null;
}

export interface FanguardApiContractsUserUserPatchRequestModel {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  currentPassword?: string | null;
  password?: string | null;
  scopes?: FanguardApiContractsUserUserRequestScopeModel[] | null;
  scopesToRemove?: string[] | null;
  sendInvitation?: boolean;
  preferences?: FanguardApiContractsUserUserPreferencesRequestModel;
  sysAdmin?: boolean | null;
}

export interface FanguardApiContractsUserUserPreferencesRequestModel {
  defaultClient?: string | null;
  alertNotifications?: FanguardApiContractsUserUserAlertNotificationPreferenceRequestModel[] | null;
  sensorNotifications?: FanguardApiContractsUserUserSensorNotificationPreferenceRequestModel;
  clientPreferences?: FanguardApiContractsUserUserClientPreferenceRequestModel;
}

export interface FanguardApiContractsUserUserPreferencesResponseModel {
  defaultClient?: string | null;
  alertNotificationPreferences?: Record<string, string[]>;
  sensorNotificationPreferences?: FanguardApiContractsUserSensorNotificationPreferencesResponseModel;
  clientPreferences?: FanguardApiContractsUserUserClientPreferenceResponseModel;
}

export interface FanguardApiContractsUserUserRequestModel {
  /**
   * @minLength 1
   * @pattern ^[a-zA-Z0-9_.@-]*$
   */
  username: string;
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /** @minLength 1 */
  email: string;
  scopes?: FanguardApiContractsUserUserRequestScopeModel[] | null;
  sysAdmin?: boolean | null;
  source?: FanguardApiContractsUserUserSourceEnum;
}

export interface FanguardApiContractsUserUserRequestScopeModel {
  client?: string | null;
  venueId?: string | null;
  permissions?: string[] | null;
  statuses?: FanguardApiContractsInteractionInteractionWorkflowStageModelEnum[] | null;
  watchlists?: string[] | null;
  venues?: string[] | null;
}

export interface FanguardApiContractsUserUserSensorNotificationPreferenceRequestModel {
  sensorStatusChange?: boolean;
  densityThresholdExceeded?: boolean | null;
  ticketRedemptionSuccessful?: boolean | null;
  ticketRedemptionPartialFailure?: boolean | null;
  venueSensorStatusChange?: string[] | null;
}

export interface FanguardApiContractsUserUserSetPasswordRequestModel {
  currentPassword?: string | null;
  /** @pattern ^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@\[\]^_`{|}~]).{10,64}$ */
  password?: string | null;
}

/** @format int32 */
export enum FanguardApiContractsUserUserSourceEnum {
  Local = 0,
  Auth0 = 1,
}

export interface FanguardApiContractsWatchlistSensorSummaryModel {
  id?: string | null;
  name?: string | null;
}

export interface FanguardApiContractsWatchlistWatchlistDetailModel {
  id?: string | null;
  /** @minLength 1 */
  name: string;
  shortName?: string | null;
  /** @format int32 */
  personCount?: number;
  context?: string | null;
  /** @format double */
  alertThreshold?: number | null;
  sensors?: FanguardApiContractsWatchlistSensorSummaryModel[] | null;
  /** @format date-time */
  createdOn?: string | null;
  createdBy?: string | null;
}

export interface FanguardApiContractsWatchlistWatchlistGeneratorModel {
  id?: string | null;
  name?: string | null;
  members?: FanguardApiContractsWatchlistWatchlistMemberGeneratorModel[] | null;
}

export interface FanguardApiContractsWatchlistWatchlistMemberGeneratorModel {
  id?: string | null;
  photos?: string[] | null;
}

export interface FanguardApiContractsWatchlistWatchlistSummaryModel {
  id?: string | null;
  /** @minLength 1 */
  name: string;
  shortName?: string | null;
  /** @format int32 */
  personCount?: number;
  context?: string | null;
  /** @format double */
  alertThreshold?: number | null;
  sensors?: FanguardApiContractsWatchlistSensorSummaryModel[] | null;
}

export interface FanguardApiControllersLinkAccountRequestModel {
  code?: string | null;
  redirectUri?: string | null;
  source?: string | null;
}

export interface FanguardApiControllersPersonImportRequestModel {
  watchlistId?: string | null;
  watchlistName?: string | null;
  watchlistPurpose?: string | null;
  /** @format binary */
  file: File;
  includesHeaderRow?: boolean;
  columnMapping?: string[] | null;
}

export interface FanguardCoreEntitiesClientPreference {
  defaultVenueId?: string | null;
}

export interface FanguardCoreEntitiesDevice {
  token?: string | null;
  client?: string | null;
  platform?: string | null;
  /** @format date-time */
  createdOn?: string;
  /** @format date-time */
  modifiedOn?: string | null;
}

/** @format int32 */
export enum FanguardCoreEntitiesInteractionWorkflowStageEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

export interface FanguardCoreEntitiesNotificationPreference {
  options?: string[] | null;
}

export interface FanguardCoreEntitiesScope {
  client?: string | null;
  venueId?: string | null;
  permissions?: string[] | null;
  statuses?: FanguardCoreEntitiesInteractionWorkflowStageEnum[] | null;
  watchlistIds?: string[] | null;
  entityId?: string | null;
  ageConfirmed?: boolean;
  venueIds?: string[] | null;
}

export interface FanguardCoreEntitiesSensorNotificationPreferences {
  sensorStatusChange?: boolean;
  densityThresholdExceeded?: boolean;
  ticketRedemptionSuccessful?: boolean;
  ticketRedemptionPartialFailure?: boolean;
  venueSensorStatusChange?: string[] | null;
}

export interface FanguardCoreEntitiesSignedAgreement {
  client?: string | null;
  agreementKey?: string | null;
  /** @format int32 */
  version?: number;
  /** @format date-time */
  signedOn?: string;
}

export interface FanguardCoreEntitiesUser {
  id?: string | null;
  hashedPassword?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  devices?: FanguardCoreEntitiesDevice[] | null;
  scopes?: FanguardCoreEntitiesScope[] | null;
  signedAgreements?: FanguardCoreEntitiesSignedAgreement[] | null;
  chatUserSid?: string | null;
  preferences?: FanguardCoreEntitiesUserPreferences;
  sysAdmin?: boolean;
  /** @format date-time */
  lockedOutOn?: string | null;
  source?: FanguardCoreEntitiesUserSource;
}

export interface FanguardCoreEntitiesUserPreferences {
  defaultClient?: string | null;
  clientPreferences?: Record<string, FanguardCoreEntitiesClientPreference>;
  notificationPreferences?: Record<string, FanguardCoreEntitiesNotificationPreference>;
  sensorNotificationPreferences?: FanguardCoreEntitiesSensorNotificationPreferences;
}

/** @format int32 */
export enum FanguardCoreEntitiesUserSource {
  Value0 = 0,
  Value1 = 1,
}

export enum SortDirection {
  Ascending = 0,
  Descending = 1,
}

export interface FanguardCoreManagersCredentialingCredentialArea {
  name?: string | null;
  identifier?: string | null;
}

export interface FanguardCoreManagersCredentialingCredentialingPrinter {
  id?: string | null;
  name?: string | null;
  groupIds?: string[] | null;
}

export interface FanguardCoreManagersCredentialingCredentialingPrinterGroup {
  id?: string | null;
  name?: string | null;
}

export interface FanguardCoreManagersCredentialingCredentialingPrinters {
  groups?: FanguardCoreManagersCredentialingCredentialingPrinterGroup[] | null;
  printers?: FanguardCoreManagersCredentialingCredentialingPrinter[] | null;
}

/** @format int32 */
export enum FanguardCoreManagersSensorControlEnum {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

export interface FanguardCoreServicesAuthenticationResult {
  status?: FanguardCoreServicesAuthenticationStatus;
  token?: string | null;
  refreshToken?: string | null;
  user?: FanguardCoreEntitiesUser;
  attemptId?: string | null;
  personToken?: string | null;
  message?: string | null;
}

/** @format int32 */
export enum FanguardCoreServicesAuthenticationStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
  Value11 = 11,
}

export interface FanguardCoreServicesTemporaryToken {
  accessKey?: string | null;
  secretAccessKey?: string | null;
  sessionToken?: string | null;
  /** @format date-time */
  expiration?: string;
}

export enum FanguardApiContractsEventReportModelFormat {
  Pdf = 'Pdf',
  Csv = 'Csv',
}

export type ReportType = 'EventSummary' | 'AllMatched';
export interface FanguardApiContractsEventReportModel {
  id?: string | null;
  name: 'Event Report';
  parameters: ('venueId' | 'startDateTime' | 'endDateTime' | 'interactionType')[];
  formats?: FanguardApiContractsEventReportModelFormat[];
  reportType?: ReportType;
}

export interface FanguardApiContractsAllMatchedReportModel {
  id?: string | null;
  name: 'All Matched Report';
  parameters: ('venueId' | 'startDateTime' | 'endDateTime')[];
  formats?: FanguardApiContractsEventReportModelFormat[];
  reportType?: ReportType;
}

export interface FanguardApiContractsReportDefinitionsResponseModel extends Array<
  FanguardApiContractsEventReportModel | FanguardApiContractsAllMatchedReportModel
> {}
